import { keyof } from 'io-ts';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, forwardRef, TemplateRef, Injectable, ElementRef, Renderer2, HostBinding, ViewContainerRef, ViewEncapsulation, ViewChild, Directive, ContentChildren, HostListener, NgModule, Optional, Injector, ComponentFactoryResolver, NgZone, defineInjectable } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { Subscription, Subject, merge } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0) { return { "height": a0 }; };
const _c1 = ["*"];
const _c2 = function (a0) { return { "collapsed": a0 }; };
const _c3 = ["inputElement"];
const _c4 = function () { return { "ico-prefix": true }; };
function FormInputComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.icon);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(3, _c4));
} }
const _c5 = function (a0, a1) { return { "eye-on": a0, "eye-off": a1 }; };
function FormInputComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function FormInputComponent_span_4_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.isPasswordVisible = !ctx_r5.isPasswordVisible; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c5, !ctx_r2.isPasswordVisible, ctx_r2.isPasswordVisible));
} }
function FormInputComponent_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵlistener("click", function FormInputComponent_ul_5_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const entry_r8 = restoredCtx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onEntryClick(entry_r8); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", entry_r8, " ");
} }
function FormInputComponent_ul_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 9);
    ɵngcc0.ɵɵtemplate(1, FormInputComponent_ul_5_li_1_Template, 2, 1, "li", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.getRelatedEntries());
} }
function FormInputComponent_small_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r4.noteId());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.note, " ");
} }
const _c6 = function (a0, a1, a2) { return { "form-control": a0, "form-control-plaintext": a1, "autocomplete": a2 }; };
const _c7 = function (a0) { return { "active": a0 }; };
const _c8 = ["dropdownMenu"];
const _c9 = ["dropdownButton"];
function DropdownItemComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.iconClass);
} }
function DropdownItemComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 3);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.iconClass);
} }
const _c10 = function (a0, a1, a2, a3) { return { "large": a0, "active": a1, "disabled": a2, "disabled-item-link": a3 }; };
function BreadcrumbItemComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.icon);
} }
function BreadcrumbItemComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.separator);
} }
function TabComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function TabGroupComponent_li_1_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 7);
} if (rf & 2) {
    const tab_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", tab_r2.icon);
} }
const _c11 = function (a1, a2) { return { "nav-link": true, "active": a1, "disabled": a2 }; };
function TabGroupComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 4)(1, "a", 5);
    ɵngcc0.ɵɵlistener("click", function TabGroupComponent_li_1_Template_a_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = restoredCtx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6._handleClick($event, i_r3); });
    ɵngcc0.ɵɵtemplate(2, TabGroupComponent_li_1_i_2_Template, 1, 1, "i", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c11, ctx_r0.selectedIndex == i_r3, tab_r2.disabled))("id", ctx_r0._getTabLabelId(i_r3));
    ɵngcc0.ɵɵattribute("aria-controls", ctx_r0._getTabContentId(i_r3))("aria-selected", ctx_r0.selectedIndex == i_r3)("aria-label", tab_r2.ariaLabel || null)("aria-labelledby", !tab_r2.ariaLabel && tab_r2.ariaLabelledby ? tab_r2.ariaLabelledby : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r2.label, " ");
} }
function TabGroupComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c12 = function (a1) { return { "tab-pane p-3": true, "show active": a1 }; };
function TabGroupComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, TabGroupComponent_ng_container_3_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c12, ctx_r1.selectedIndex == i_r9))("id", ctx_r1._getTabContentId(i_r9));
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r1._getTabLabelId(i_r9));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r8._implicitContent);
} }
const _c13 = function (a0, a1, a2) { return { "nav-dark": a0, "nav-tabs": a1, "nav-pills mb-3": a2 }; };
const ThemeColor = keyof({
    primary: null,
    secondary: null,
    danger: null,
    warning: null,
    info: null,
    success: null,
    light: null,
    dark: null,
});
/** @type {?} */
const PRIMARY = 'primary';
/** @type {?} */
const SECONDARY = 'secondary';
/** @type {?} */
const DANGER = 'danger';
/** @type {?} */
const WARNING = 'warning';
/** @type {?} */
const INFO = 'info';
/** @type {?} */
const SUCCESS = 'success';
/** @type {?} */
const LIGHT = 'light';
/** @type {?} */
const DARK = 'dark';
/** @type {?} */
const THEME_COLORS = {
    PRIMARY: PRIMARY,
    SECONDARY: SECONDARY,
    DANGER: DANGER,
    WARNING: WARNING,
    INFO: INFO,
    SUCCESS: SUCCESS,
    LIGHT: LIGHT,
    DARK: DARK
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let progressbarId = 0;
/**
 * Una barra di avanzamento con design bootstrap italia.
 */
class ProgressBarComponent {
    constructor() {
        this.progressbarId = `it-progress-bar-${progressbarId++}`;
        this._height = ProgressBarComponent.PROGRESS_BAR_DEFAULT_HEIGHT;
        this._min = ProgressBarComponent.PROGRESS_BAR_DEFAULT_MIN;
        this._max = ProgressBarComponent.PROGRESS_BAR_DEFAULT_MAX;
        this._value = ProgressBarComponent.PROGRESS_BAR_DEFAULT_VALUE;
        this._label = ProgressBarComponent.PROGRESS_BAR_DEFAULT_LABEL;
        this._color = THEME_COLORS.PRIMARY;
    }
    /**
     * L'altezza della barra di avanzamento.
     * @return {?}
     */
    get height() { return this._height; }
    /**
     * @param {?} v
     * @return {?}
     */
    set height(v) { this._height = v; }
    /**
     * Il valore minimo della barra di avanzamento.
     * @return {?}
     */
    get min() { return this._min; }
    /**
     * @param {?} v
     * @return {?}
     */
    set min(v) { this._min = Math.round(v); }
    /**
     * Il valore massimo della barra di avanzamento.
     * @return {?}
     */
    get max() { return this._max; }
    /**
     * @param {?} v
     * @return {?}
     */
    set max(v) { this._max = Math.round(v); }
    /**
     * L'attuale valore della barra di avanzamento.
     * @return {?}
     */
    get value() { return this._value; }
    /**
     * @param {?} v
     * @return {?}
     */
    set value(v) { this._value = Math.min(Math.max(v, this._min), this._max); }
    /**
     * L'etichetta della barra di avanzamento.
     * @return {?}
     */
    get label() { return this._label; }
    /**
     * @param {?} v
     * @return {?}
     */
    set label(v) { this._label = v; }
    /**
     * Il colore della barra di avanzamento.
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set color(value) {
        if (ThemeColor.is(value)) {
            this._color = value;
        }
        else {
            this._color = THEME_COLORS.PRIMARY;
        }
    }
    /**
     * @return {?}
     */
    valuePercentage() {
        return ((this.value - this.min) * 100) / (this.max - this.min);
    }
    /**
     * @return {?}
     */
    pgStyle() {
        return { 'width': this.valuePercentage() + '%' };
    }
    /**
     * @return {?}
     */
    pgClass() {
        /** @type {?} */
        const progressbarClass = { 'progress-bar': true };
        if (this.color) {
            progressbarClass[`bg-${this.color}`] = true;
        }
        return progressbarClass;
    }
}
ProgressBarComponent.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(); };
ProgressBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["it-progress-bar"]], inputs: { height: "height", min: "min", max: "max", value: "value", label: "label", color: "color" }, decls: 3, vars: 10, consts: [[1, "progress", 3, "ngStyle"], ["role", "progressbar", 3, "id", "ngClass", "ngStyle"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c0, ctx.height + "px"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.progressbarId)("ngClass", ctx.pgClass())("ngStyle", ctx.pgStyle());
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.value)("aria-valuemin", ctx.min)("aria-valuemax", ctx.max);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass], styles: [""], changeDetection: 0 });
ProgressBarComponent.PROGRESS_BAR_DEFAULT_MIN = 0;
ProgressBarComponent.PROGRESS_BAR_DEFAULT_MAX = 100;
ProgressBarComponent.PROGRESS_BAR_DEFAULT_VALUE = 0;
ProgressBarComponent.PROGRESS_BAR_DEFAULT_HEIGHT = 20;
ProgressBarComponent.PROGRESS_BAR_DEFAULT_LABEL = '';
/** @nocollapse */
ProgressBarComponent.ctorParameters = () => [];
ProgressBarComponent.propDecorators = {
    height: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    value: [{ type: Input }],
    label: [{ type: Input }],
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'it-progress-bar',
                template: `<div class="progress" [ngStyle]="{'height': height + 'px'}">
  <div role="progressbar" [id]="progressbarId" [ngClass]="pgClass()" [ngStyle]="pgStyle()"
    [attr.aria-valuenow]="value" [attr.aria-valuemin]="min" [attr.aria-valuemax]="max" >
    {{label}}
  </div>
</div>`,
                styles: [``],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { height: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], value: [{
            type: Input
        }], label: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier = 0;
class CheckboxChange {
}
/**
 * Una checkbox con design bootstrap italia. Supporta tutte le funzionalità di una checkbox HTML5,
 * ed espone una API simile. Una `<it-checkbox>` può essere checked, unchecked, o disabled.
 */
class CheckboxComponent {
    /**
     * @param {?} _changeDetectorRef
     */
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this._checked = false;
        this._disabled = false;
        /**
         * Evento emesso quando il valore `checked` della checkbox cambia.
         */
        this.change = new EventEmitter();
        this.inputId = `checkbox-${identifier++}`;
        this._onTouched = () => { };
        this._controlValueAccessorChangeFn = () => { };
    }
    /**
     * Se la checkbox è selezionata.
     * @return {?}
     */
    get checked() { return this._checked; }
    /**
     * @param {?} value
     * @return {?}
     */
    set checked(value) {
        if (value !== this.checked) {
            this._checked = value;
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * Se la checkbox è disabilitata.
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        if (value !== this.disabled) {
            this._disabled = value;
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.checked = !!value;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handleChange(event) {
        event.stopPropagation();
        if (!this.disabled) {
            this._toggle();
            this._emitChangeEvent();
        }
    }
    /**
     * @return {?}
     */
    _toggle() {
        this.checked = !this.checked;
    }
    /**
     * @return {?}
     */
    _emitChangeEvent() {
        /** @type {?} */
        const event = new CheckboxChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["it-checkbox"]], inputs: { checked: "checked", disabled: "disabled", label: "label" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true }])], decls: 4, vars: 5, consts: [[1, "form-check"], ["type", "checkbox", 3, "id", "checked", "disabled", "change"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        ɵngcc0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_1_listener($event) { return ctx.handleChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.inputId)("checked", ctx.checked)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, styles: [""], changeDetection: 0 });
/** @nocollapse */
CheckboxComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CheckboxComponent.propDecorators = {
    checked: [{ type: Input }],
    label: [{ type: Input }],
    disabled: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'it-checkbox',
                template: `<div class=form-check>
  <input type=checkbox
    [id]=inputId
    [checked]=checked
    [disabled]=disabled
    (change)=handleChange($event)>
  <label
    [attr.for]=inputId>{{label}}</label>
</div>
`,
                styles: [``],
                providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true }],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { change: [{
            type: Output
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright Angular ng-bootstrap team All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/ng-bootstrap/ng-bootstrap/master/LICENSE
 */
class Trigger {
    /**
     * @param {?} open
     * @param {?=} close
     */
    constructor(open, close) {
        this.open = open;
        this.close = close;
        if (!close) {
            this.close = open;
        }
    }
    /**
     * @return {?}
     */
    isManual() { return this.open === 'manual' || this.close === 'manual'; }
}
/** @type {?} */
const DEFAULT_ALIASES = {
    'hover': ['mouseenter', 'mouseleave'],
    'focus': ['focus', 'blur']
};
/**
 * @param {?} triggers
 * @param {?=} aliases
 * @return {?}
 */
function parseTriggers(triggers, aliases = DEFAULT_ALIASES) {
    /** @type {?} */
    const trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    /** @type {?} */
    const parsedTriggers = trimmedTriggers.split(/\s+/).map(trigger => trigger.split(':')).map((triggerPair) => {
        /** @type {?} */
        const alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger(alias[0], alias[1]);
    });
    /** @type {?} */
    const manualTriggers = parsedTriggers.filter(triggerPair => triggerPair.isManual());
    if (manualTriggers.length > 1) {
        throw new Error('Triggers parse error: only one manual trigger is allowed');
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw new Error('Triggers parse error: manual trigger can\'t be mixed with other triggers');
    }
    return parsedTriggers;
}
/** @type {?} */
const noopFn = () => { };
/**
 * @param {?} renderer
 * @param {?} nativeElement
 * @param {?} triggers
 * @param {?} openFn
 * @param {?} closeFn
 * @param {?} toggleFn
 * @return {?}
 */
function listenToTriggers(renderer, nativeElement, triggers, openFn, closeFn, toggleFn) {
    /** @type {?} */
    const parsedTriggers = parseTriggers(triggers);
    /** @type {?} */
    const listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return noopFn;
    }
    parsedTriggers.forEach((trigger) => {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(nativeElement, trigger.open, toggleFn));
        }
        else {
            listeners.push(renderer.listen(nativeElement, trigger.open, openFn), renderer.listen(nativeElement, trigger.close, closeFn));
        }
    });
    return () => { listeners.forEach(unsubscribeFn => unsubscribeFn()); };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright Angular ng-bootstrap team All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/ng-bootstrap/ng-bootstrap/master/LICENSE
 */
class Positioning {
    /**
     * @param {?} element
     * @return {?}
     */
    getAllStyles(element) { return window.getComputedStyle(element); }
    /**
     * @param {?} element
     * @param {?} prop
     * @return {?}
     */
    getStyle(element, prop) { return this.getAllStyles(element)[prop]; }
    /**
     * @param {?} element
     * @return {?}
     */
    isStaticPositioned(element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    }
    /**
     * @param {?} element
     * @return {?}
     */
    offsetParent(element) {
        /** @type {?} */
        let offsetParentEl = /** @type {?} */ (element.offsetParent) || document.documentElement;
        while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = /** @type {?} */ (offsetParentEl.offsetParent);
        }
        return offsetParentEl || document.documentElement;
    }
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    position(element, round = true) {
        /** @type {?} */
        let elPosition;
        /** @type {?} */
        let parentOffset = { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
        if (this.getStyle(element, 'position') === 'fixed') {
            elPosition = element.getBoundingClientRect();
        }
        else {
            /** @type {?} */
            const offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    }
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    offset(element, round = true) {
        /** @type {?} */
        const elBcr = element.getBoundingClientRect();
        /** @type {?} */
        const viewportOffset = {
            top: window.pageYOffset - document.documentElement.clientTop,
            left: window.pageXOffset - document.documentElement.clientLeft
        };
        /** @type {?} */
        const elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    }
    /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @param {?} placement
     * @param {?=} appendToBody
     * @return {?}
     */
    positionElements(hostElement, targetElement, placement, appendToBody) {
        /** @type {?} */
        const hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
        /** @type {?} */
        const targetElStyles = this.getAllStyles(targetElement);
        /** @type {?} */
        const targetElBCR = targetElement.getBoundingClientRect();
        /** @type {?} */
        const placementPrimary = placement.split('-')[0] || 'top';
        /** @type {?} */
        const placementSecondary = placement.split('-')[1] || 'center';
        /** @type {?} */
        const targetElPosition = {
            'height': targetElBCR.height || targetElement.offsetHeight,
            'width': targetElBCR.width || targetElement.offsetWidth,
            'top': 0,
            'bottom': targetElBCR.height || targetElement.offsetHeight,
            'left': 0,
            'right': targetElBCR.width || targetElement.offsetWidth
        };
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top =
                    hostElPosition.top - (targetElement.offsetHeight + parseFloat(targetElStyles.marginBottom));
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height;
                break;
            case 'left':
                targetElPosition.left =
                    hostElPosition.left - (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width;
                break;
        }
        switch (placementSecondary) {
            case 'top':
                targetElPosition.top = hostElPosition.top;
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left;
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
                break;
            case 'center':
                if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                    targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
                }
                else {
                    targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
                }
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    }
    /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @return {?}
     */
    getAvailablePlacements(hostElement, targetElement) {
        /** @type {?} */
        const availablePlacements = [];
        /** @type {?} */
        const hostElemClientRect = hostElement.getBoundingClientRect();
        /** @type {?} */
        const targetElemClientRect = targetElement.getBoundingClientRect();
        /** @type {?} */
        const html = document.documentElement;
        /** @type {?} */
        const windowHeight = window.innerHeight || html.clientHeight;
        /** @type {?} */
        const windowWidth = window.innerWidth || html.clientWidth;
        /** @type {?} */
        const hostElemClientRectHorCenter = hostElemClientRect.left + hostElemClientRect.width / 2;
        /** @type {?} */
        const hostElemClientRectVerCenter = hostElemClientRect.top + hostElemClientRect.height / 2;
        // controlla se la larghezza dell'elemento target può essere collocata tra la sinistra dell'host e l'inizio della viewport
        // e controlla anche se l'altezza del target è nella viewport
        if (targetElemClientRect.width < hostElemClientRect.left) {
            // controlla solo per la sinistra
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'left');
            }
            // controlla solo per le varianti di sinistra left-top and left-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'left', availablePlacements);
        }
        // controlla se l'altezza del target è minore della cima dell'host
        if (targetElemClientRect.height < hostElemClientRect.top) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'top');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'top', availablePlacements);
        }
        // controlla se la larghezza dell'elemento target può essere collocata tra la destra dell'host e la fine della viewport
        // e controlla anche se l'altezza del target è nella viewport
        if (windowWidth - hostElemClientRect.right > targetElemClientRect.width) {
            // controlla solo per la destra
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'right');
            }
            // controlla solo per le varianti di destra right-top and right-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'right', availablePlacements);
        }
        // controlla se c'è abbastanza spazio tra la base dell'host e la fine della viewport per l'altezza del target
        if (windowHeight - hostElemClientRect.bottom > targetElemClientRect.height) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'bottom');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'bottom', availablePlacements);
        }
        return availablePlacements;
    }
    /**
     * Controlla se il collocamento secondario per sinistra e destra è disponibile, come left-top, left-bottom, right-top e right-bottom
     * primaryplacement: left|right
     * availablePlacementArr: array con i collocamenti disponibili
     * @param {?} hostElemClientRect
     * @param {?} targetElemClientRect
     * @param {?} primaryPlacement
     * @param {?} availablePlacementArr
     * @return {?}
     */
    setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        /** @type {?} */
        const html = document.documentElement;
        // check for left-bottom
        if (targetElemClientRect.height <= hostElemClientRect.bottom) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-bottom');
        }
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.top >= targetElemClientRect.height) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-top');
        }
    }
    /**
     * Controlla se il collocamento secondario per sopra e sotto è disponibile, come top-left, top-right, bottom-left, bottom-right
     * primaryplacement: top|bottom
     * availablePlacementArr: array con i collocamenti disponibili
     * @param {?} hostElemClientRect
     * @param {?} targetElemClientRect
     * @param {?} primaryPlacement
     * @param {?} availablePlacementArr
     * @return {?}
     */
    setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        /** @type {?} */
        const html = document.documentElement;
        // check for left-bottom
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.left >= targetElemClientRect.width) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-left');
        }
        if (targetElemClientRect.width <= hostElemClientRect.right) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-right');
        }
    }
}
/** @type {?} */
const positionService = new Positioning();
/**
 * @param {?} hostElement
 * @param {?} targetElement
 * @param {?} placement
 * @param {?=} appendToBody
 * @return {?}
 */
function positionElements(hostElement, targetElement, placement, appendToBody) {
    /** @type {?} */
    const placementVals = Array.isArray(placement) ? placement : [/** @type {?} */ (placement)];
    /** @type {?} */
    let hasAuto = placementVals.findIndex(val => val === 'auto');
    if (hasAuto >= 0) {
        ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top',
            'left-bottom', 'right-top', 'right-bottom',
        ].forEach(function (obj) {
            if (placementVals.find(val => val.search('^' + obj) !== -1) == null) {
                placementVals.splice(hasAuto++, 1, /** @type {?} */ (obj));
            }
        });
    }
    /** @type {?} */
    let topVal = 0;
    /** @type {?} */
    let leftVal = 0;
    /** @type {?} */
    let appliedPlacement;
    /** @type {?} */
    const availablePlacements = positionService.getAvailablePlacements(hostElement, targetElement);
    // iterare sui collocamenti acquisiti
    for (const { item, index } of toItemIndexes(placementVals)) {
        // Controlla se il collocamento passato è presente nel collocamento disponibile, altrimenti applica l'ultimo collocamento nella
        // lista del collocamento passato
        if ((availablePlacements.find(val => val === item) != null) || (placementVals.length === index + 1)) {
            appliedPlacement = /** @type {?} */ (item);
            /** @type {?} */
            const pos = positionService.positionElements(hostElement, targetElement, item, appendToBody);
            topVal = pos.top;
            leftVal = pos.left;
            break;
        }
    }
    targetElement.style.top = `${topVal}px`;
    targetElement.style.left = `${leftVal}px`;
    return appliedPlacement;
}
/**
 * @template T
 * @param {?} a
 * @return {?}
 */
function toItemIndexes(a) {
    return a.map((item, index) => ({ item, index }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ContentRef {
    /**
     * @param {?} nodes
     * @param {?=} viewRef
     * @param {?=} componentRef
     */
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
/**
 * @template T
 */
class PopupService {
    /**
     * @param {?} _type
     * @param {?} _injector
     * @param {?} _viewContainerRef
     * @param {?} _renderer
     * @param {?} _componentFactoryResolver
     */
    constructor(_type, _injector, _viewContainerRef, _renderer, _componentFactoryResolver) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._componentFactoryResolver = _componentFactoryResolver;
    }
    /**
     * @param {?=} content
     * @param {?=} context
     * @return {?}
     */
    open(content, context) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), 0, this._injector, this._contentRef.nodes);
        }
        return this._windowRef;
    }
    /**
     * @return {?}
     */
    close() {
        if (this._windowRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
            this._windowRef = null;
            if (this._contentRef.viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
                this._contentRef = null;
            }
        }
    }
    /**
     * @param {?} content
     * @param {?=} context
     * @return {?}
     */
    _getContentRef(content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof TemplateRef) {
            /** @type {?} */
            const viewRef = this._viewContainerRef.createEmbeddedView(/** @type {?} */ (content), context);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef([[this._renderer.createText(`${content}`)]]);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const InteractionTrigger = keyof({
    click: null,
    focus: null,
    hover: null,
});
/** @type {?} */
const PopoverTrigger = keyof({
    click: null,
    focus: null,
});
/** @type {?} */
const CLICK = 'click';
/** @type {?} */
const FOCUS = 'focus';
/** @type {?} */
const HOVER = 'hover';
/** @type {?} */
const INTERACTION_TRIGGERS = {
    CLICK: CLICK,
    FOCUS: FOCUS,
    HOVER: HOVER,
};
/** @type {?} */
const POPOVER_TRIGGERS = {
    CLICK: CLICK,
    FOCUS: FOCUS,
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Servizio di configurazione per la direttiva ItPopover.
 * Il servizio può essere iniettato, tipicamente in un root component, per impostare i valori delle proprietà in
 * modo tale da fornire i valori di default per tutti i popover utilizzati in un'applicazione.
 */
class PopoverConfig {
    constructor() {
        this.placement = 'right';
        this.triggers = INTERACTION_TRIGGERS.CLICK;
        this.disablePopover = false;
    }
}
PopoverConfig.ɵfac = function PopoverConfig_Factory(t) { return new (t || PopoverConfig)(); };
PopoverConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PopoverConfig, factory: PopoverConfig.ɵfac, providedIn: 'root' });
/** @nocollapse */ PopoverConfig.ngInjectableDef = defineInjectable({ factory: function PopoverConfig_Factory() { return new PopoverConfig(); }, token: PopoverConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class PopoverComponent {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _changeDetectorRef
     * @param {?} _viewContainerRef
     */
    constructor(_element, _renderer, _changeDetectorRef, _viewContainerRef) {
        this._element = _element;
        this._renderer = _renderer;
        this._changeDetectorRef = _changeDetectorRef;
        this._viewContainerRef = _viewContainerRef;
        this.placement = 'right';
        this.hidden = false;
        this.role = 'tooltip';
    }
    /**
     * @return {?}
     */
    get title() { return this._title; }
    /**
     * @param {?} value
     * @return {?}
     */
    set title(value) {
        this._title = value;
        this._changeDetectorRef.detectChanges();
    }
    /**
     * @return {?}
     */
    get myCssClass() {
        return 'popover bs-popover-' + this.placement.split('-')[0] + ' bs-popover-' + this.placement;
    }
    /**
     * @param {?} _placement
     * @return {?}
     */
    applyPlacement(_placement) {
        // Rimuovi le classi della posizione precedente
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
        // Imposta la nuova posizione
        this.placement = _placement;
        // Applica le classi della nuova posizione
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
    }
    /**
     * @param {?} content
     * @param {?=} context
     * @return {?}
     */
    setNewContent(content, context) {
        /** @type {?} */
        const contentElement = this._element.nativeElement.querySelector('.popover-body');
        /** @type {?} */
        let newContent;
        if (!content) {
            newContent = new ContentRef([]);
        }
        else if (content instanceof TemplateRef) {
            /** @type {?} */
            const viewRef = this._viewContainerRef.createEmbeddedView(/** @type {?} */ (content), context);
            newContent = new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            newContent = new ContentRef([[this._renderer.createText(`${content}`)]]);
        }
        /** @type {?} */
        const childNodes = contentElement.childNodes;
        for (let i = 0; i < childNodes.length; i++) {
            this._renderer.removeChild(contentElement, childNodes[i]);
        }
        newContent.nodes.forEach(newNode => {
            newNode.forEach(newChild => this._renderer.appendChild(contentElement, newChild));
        });
    }
}
PopoverComponent.ɵfac = function PopoverComponent_Factory(t) { return new (t || PopoverComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
PopoverComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopoverComponent, selectors: [["it-popover-window"]], hostVars: 5, hostBindings: function PopoverComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("hidden", ctx.hidden)("id", ctx.id);
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassMap(ctx.myCssClass);
    } }, inputs: { placement: "placement", hidden: "hidden", title: "title", id: "id" }, ngContentSelectors: _c1, decls: 5, vars: 1, consts: [[1, "arrow"], [1, "popover-header"], [1, "popover-body"]], template: function PopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h3", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, styles: [".bs-popover-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:50%;margin-left:-5px}.bs-popover-bottom-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-top-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:2em}.bs-popover-bottom-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-top-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:auto;right:2em}.bs-popover-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:50%;margin-top:-5px}.bs-popover-left-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:.7em}.bs-popover-left-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:auto;bottom:.7em}"], changeDetection: 0 });
/** @nocollapse */
PopoverComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: ViewContainerRef }
];
PopoverComponent.propDecorators = {
    placement: [{ type: Input }],
    title: [{ type: Input }],
    id: [{ type: Input }, { type: HostBinding, args: ['id',] }],
    hidden: [{ type: Input }, { type: HostBinding, args: ['hidden',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    myCssClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverComponent, [{
        type: Component,
        args: [{
                selector: 'it-popover-window',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `<div class="arrow"></div>
<h3 class="popover-header">{{title}}</h3>
<div class="popover-body">
  <ng-content></ng-content>
</div>`,
                styles: [`:host.bs-popover-bottom .arrow,:host.bs-popover-top .arrow{left:50%;margin-left:-5px}:host.bs-popover-bottom-left .arrow,:host.bs-popover-top-left .arrow{left:2em}:host.bs-popover-bottom-right .arrow,:host.bs-popover-top-right .arrow{left:auto;right:2em}:host.bs-popover-left .arrow,:host.bs-popover-right .arrow{top:50%;margin-top:-5px}:host.bs-popover-left-top .arrow,:host.bs-popover-right-top .arrow{top:.7em}:host.bs-popover-left-bottom .arrow,:host.bs-popover-right-bottom .arrow{top:auto;bottom:.7em}`]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ViewContainerRef }]; }, { placement: [{
            type: Input
        }], hidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['hidden']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], title: [{
            type: Input
        }], myCssClass: [{
            type: HostBinding,
            args: ['class']
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['id']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Util {
    /**
     * @param {?} value
     * @return {?}
     */
    static coerceBooleanProperty(value) {
        return value != null && `${value}` !== 'false';
    }
    /**
     * @param {?} value
     * @param {?=} fallbackValue
     * @return {?}
     */
    static coerceNumberProperty(value, fallbackValue = 0) {
        return Util._isNumberValue(value) ? Number(value) : fallbackValue;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static _isNumberValue(value) {
        return !isNaN(parseFloat(/** @type {?} */ (value))) && !isNaN(Number(value));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$1 = 0;
/**
 * Una direttiva per la creazione di un popover.
 */
class PopoverDirective {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} injector
     * @param {?} componentFactoryResolver
     * @param {?} viewContainerRef
     * @param {?} config
     * @param {?} ngZone
     */
    constructor(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._showEvent = new EventEmitter();
        this._shownEvent = new EventEmitter();
        this._insertedEvent = new EventEmitter();
        this._hideEvent = new EventEmitter();
        this._hiddenEvent = new EventEmitter();
        this._disablePopover = false;
        this._itPopoverWindowId = `it-popover-${identifier$1++}`;
        this.placement = config.placement;
        this.triggers = config.triggers;
        this.container = config.container;
        this.disablePopover = config.disablePopover;
        this._popupService = new PopupService(PopoverComponent, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(() => {
            if (this._windowRef) {
                this._windowRef.instance.applyPlacement(positionElements(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            }
        });
    }
    /**
     * Contenuto da mostrare nel popover. In assenza di titolo e contenuto, il popover non si aprirà.
     * @return {?}
     */
    get itPopover() { return this._itPopover; }
    /**
     * @param {?} value
     * @return {?}
     */
    set itPopover(value) { this._itPopover = value; }
    /**
     * Titolo del popover. In assenza di titolo e contenuto, il popover non si aprirà.
     * @return {?}
     */
    get title() { return this._title; }
    /**
     * @param {?} value
     * @return {?}
     */
    set title(value) { this._title = value; }
    /**
     * Il collocamento accettato dal popover:
     *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
     *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
     * ed array dei valori soprariportati.
     * @return {?}
     */
    get placement() { return this._placement; }
    /**
     * @param {?} value
     * @return {?}
     */
    set placement(value) { this._placement = value; }
    /**
     * Specifica gli eventi che dovrebbero innescare il popover. Supporta una lista con nomi di eventi separati da spazi.
     * @return {?}
     */
    get triggers() {
        return this._triggers;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set triggers(value) {
        if (PopoverTrigger.is(value)) {
            this._triggers = value;
        }
        else {
            this._triggers = POPOVER_TRIGGERS.CLICK;
        }
    }
    /**
     * Un selettore che specifica l'elemento in cui il popover dovrebbe essere aggiunto.
     * Attualmente supporta solo "body".
     * @return {?}
     */
    get container() { return this._container; }
    /**
     * @param {?} value
     * @return {?}
     */
    set container(value) { this._container = value; }
    /**
     * Evento da emettere quando il popover sta per essere mostrato
     * @return {?}
     */
    get showEvent() { return this._showEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set showEvent(value) { this._showEvent = value; }
    /**
     * Evento da emettere quando il popover è mostrato
     * @return {?}
     */
    get shownEvent() { return this._shownEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set shownEvent(value) { this._shownEvent = value; }
    /**
     * Evento da emettere quando il popover viene inserito nel DOM
     * @return {?}
     */
    get insertedEvent() { return this._insertedEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set insertedEvent(value) { this._insertedEvent = value; }
    /**
     * Evento da emettere quando il popover sta per essere nascosto
     * @return {?}
     */
    get hideEvent() { return this._hideEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hideEvent(value) { this._hideEvent = value; }
    /**
     * Evento da emettere quando il popover è nascosto
     * @return {?}
     */
    get hiddenEvent() { return this._hiddenEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hiddenEvent(value) { this._hiddenEvent = value; }
    /**
     * Un flag utilizzato per indicare se un popover è disabilitato, così da non doverlo mostrare.
     * @return {?}
     */
    get disablePopover() { return this._disablePopover; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disablePopover(value) { this._disablePopover = Util.coerceBooleanProperty(value); }
    /**
     * @return {?}
     */
    _isDisabled() {
        if (this.disablePopover) {
            return true;
        }
        if (!this.itPopover && !this.title) {
            return true;
        }
        return false;
    }
    /**
     * Apre il popover di un elemento. È considerato un azionamento "manuale" del popover.
     * Il context è un valore opzionale da iniettare nel template del popover quando esso viene creato.
     * @param {?=} context
     * @return {?}
     */
    show(context) {
        if (!this._isDisabled()) {
            // Scatena l'evento per segnalare l'inizio del processo per visualizzare il popover
            this.showEvent.emit(this);
            if (!this._windowRef) {
                this._windowRef = this._popupService.open(this.itPopover, context);
                /** @type {?} */
                const popoverComponent = this._windowRef.instance;
                popoverComponent.title = this.title;
                popoverComponent.id = this._itPopoverWindowId;
                this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._itPopoverWindowId);
                if (this.container === 'body') {
                    window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
                }
                this._windowRef.changeDetectorRef.detectChanges();
                this._windowRef.changeDetectorRef.markForCheck();
                // Posiziona il popover attorno all'elemento
                popoverComponent.applyPlacement(positionElements(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
                // Scatena l'evento per segnalare l'inserimento nel DOM
                this.insertedEvent.emit(this);
            }
            else {
                /** @type {?} */
                const popoverComponent = this._windowRef.instance;
                popoverComponent.hidden = false;
            }
            // Scatena l'evento per segnalare che il popover è stato visualizzato
            this.shownEvent.emit(this);
        }
    }
    /**
     * Chiude il popover di un elemento. È considerato un azionamento "manuale" del popover.
     * @return {?}
     */
    hide() {
        // Scatena l'evento per segnalare l'inizio del processo per nascondere il popover
        this.hideEvent.emit(this);
        if (this._windowRef) {
            /** @type {?} */
            const popoverComponent = this._windowRef.instance;
            popoverComponent.hidden = true;
            // Scatena l'evento per segnalare che il popover è stato nascosto
            this.hiddenEvent.emit(this);
        }
    }
    /**
     * Apre/chiude il un popover di un elemento. È considerato un azionamento "manuale" del popover.
     * @return {?}
     */
    toggle() {
        if (this._windowRef) {
            if (this._windowRef.instance.hidden) {
                this.show();
            }
            else {
                this.hide();
            }
        }
        else {
            this.show();
        }
    }
    /**
     * Nasconde e distrugge il popover di un elemento.
     * @return {?}
     */
    dispose() {
        /** @type {?} */
        const isShown = this._windowRef ? !this._windowRef.instance.hidden : false;
        if (isShown) {
            this.hide();
        }
        if (this._windowRef) {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
            this._popupService.close();
            this._windowRef = null;
        }
    }
    /**
     * Fornisce al popover di un elemento la possibilità di essere mostrato.
     * @return {?}
     */
    enable() {
        if (this._isDisabled()) {
            this.disablePopover = false;
        }
    }
    /**
     * Rimuove la capacità di mostrare il popover di un elemento.
     * @return {?}
     */
    disable() {
        if (!this._isDisabled()) {
            this.disablePopover = true;
        }
    }
    /**
     * Attiva/disattiva la possibilità che il popover di un elemento sia mostrato o nascosto.
     * @return {?}
     */
    toggleEnabled() {
        if (this._isDisabled()) {
            this.enable();
        }
        else {
            this.disable();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._unregisterListenersFn = listenToTriggers(this._renderer, this._elementRef.nativeElement, this.triggers, this.show.bind(this), this.hide.bind(this), this.toggle.bind(this));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        // Chiude il popover se titolo e contenuti risultano vuoti, o se disablePopover è impostato a vero
        if (changes['itPopover'] || changes['title'] || changes['disablePopover']) {
            if (this._windowRef) {
                /** @type {?} */
                const isShown = !this._windowRef.instance.hidden;
                if (changes['itPopover']) {
                    this._windowRef.instance.setNewContent(this.itPopover);
                    this._windowRef.changeDetectorRef.detectChanges();
                    this._windowRef.changeDetectorRef.markForCheck();
                }
                if (changes['title']) {
                    this._windowRef.instance.title = this.title;
                }
                if (isShown) {
                    if (!this._isDisabled()) {
                        this.show();
                    }
                    else {
                        this.hide();
                    }
                }
            }
        }
        else if (changes['placement']) {
            if (this._windowRef) {
                this._windowRef.instance.applyPlacement(positionElements(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            }
        }
        else if (changes['container']) {
            /** @type {?} */
            const isShown = this._windowRef ? !this._windowRef.instance.hidden : false;
            this.dispose();
            if (isShown) {
                this.show();
            }
        }
        else if (changes['triggers']) {
            this.dispose();
            /** @type {?} */
            const triggersChangers = changes['triggers'];
            if (triggersChangers.previousValue !== triggersChangers.currentValue && !triggersChangers.firstChange) {
                this._unregisterListenersFn();
                this._unregisterListenersFn = listenToTriggers(this._renderer, this._elementRef.nativeElement, this.triggers, this.show.bind(this), this.hide.bind(this), this.toggle.bind(this));
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.dispose();
        this._unregisterListenersFn();
        this._zoneSubscription.unsubscribe();
    }
}
PopoverDirective.ɵfac = function PopoverDirective_Factory(t) { return new (t || PopoverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(PopoverConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
PopoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PopoverDirective, selectors: [["", "it-popover", ""]], inputs: { placement: "placement", triggers: "triggers", container: "container", disablePopover: ["disabled", "disablePopover"], itPopover: ["it-popover", "itPopover"], title: "title" }, outputs: { showEvent: "show", shownEvent: "shown", insertedEvent: "inserted", hideEvent: "hide", hiddenEvent: "hidden" }, exportAs: ["it-popover"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
PopoverDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: Injector },
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef },
    { type: PopoverConfig },
    { type: NgZone }
];
PopoverDirective.propDecorators = {
    itPopover: [{ type: Input, args: ['it-popover',] }],
    title: [{ type: Input }],
    placement: [{ type: Input }],
    triggers: [{ type: Input }],
    container: [{ type: Input }],
    showEvent: [{ type: Output, args: ['show',] }],
    shownEvent: [{ type: Output, args: ['shown',] }],
    insertedEvent: [{ type: Output, args: ['inserted',] }],
    hideEvent: [{ type: Output, args: ['hide',] }],
    hiddenEvent: [{ type: Output, args: ['hidden',] }],
    disablePopover: [{ type: Input, args: ['disabled',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverDirective, [{
        type: Directive,
        args: [{
                selector: '[it-popover]',
                // tslint:disable-line
                exportAs: 'it-popover'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: PopoverConfig }, { type: ɵngcc0.NgZone }]; }, { placement: [{
            type: Input
        }], triggers: [{
            type: Input
        }], container: [{
            type: Input
        }], disablePopover: [{
            type: Input,
            args: ['disabled']
        }], itPopover: [{
            type: Input,
            args: ['it-popover']
        }], title: [{
            type: Input
        }], showEvent: [{
            type: Output,
            args: ['show']
        }], shownEvent: [{
            type: Output,
            args: ['shown']
        }], insertedEvent: [{
            type: Output,
            args: ['inserted']
        }], hideEvent: [{
            type: Output,
            args: ['hide']
        }], hiddenEvent: [{
            type: Output,
            args: ['hidden']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$2 = 0;
class ToggleChange {
}
/**
 * Una toggle con design bootstrap italia. Supporta tutte le funzionalità di una checkbox HTML5,
 * ed espone una API simile. Una `<it-toggle>` può essere checked, unchecked, o disabled.
 */
class ToggleComponent {
    /**
     * @param {?} _changeDetectorRef
     */
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this._checked = false;
        this._disabled = false;
        /**
         * Evento emesso quando il valore `checked` della toggle cambia.
         */
        this.change = new EventEmitter();
        this.inputId = `toggle-${identifier$2++}`;
        this._onTouched = () => { };
        this._controlValueAccessorChangeFn = () => { };
    }
    /**
     * Se la toggle è selezionata.
     * @return {?}
     */
    get checked() { return this._checked; }
    /**
     * @param {?} value
     * @return {?}
     */
    set checked(value) {
        if (value !== this.checked) {
            this._checked = value;
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * Se la toggle è disabilitata.
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        if (value !== this.disabled) {
            this._disabled = value;
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.checked = !!value;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handleChange(event) {
        event.stopPropagation();
        if (!this.disabled) {
            this._toggle();
            this._emitChangeEvent();
        }
    }
    /**
     * @return {?}
     */
    _toggle() {
        this.checked = !this.checked;
    }
    /**
     * @return {?}
     */
    _emitChangeEvent() {
        /** @type {?} */
        const event = new ToggleChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    }
}
ToggleComponent.ɵfac = function ToggleComponent_Factory(t) { return new (t || ToggleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ToggleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToggleComponent, selectors: [["it-toggle"]], inputs: { checked: "checked", disabled: "disabled", label: "label" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ToggleComponent), multi: true }])], decls: 6, vars: 5, consts: [[1, "form-check"], [1, "toggles"], ["type", "checkbox", 3, "id", "checked", "disabled", "change"], [1, "lever"]], template: function ToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("change", function ToggleComponent_Template_input_change_4_listener($event) { return ctx.handleChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "span", 3);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.inputId)("checked", ctx.checked)("disabled", ctx.disabled);
    } }, styles: [""], changeDetection: 0 });
/** @nocollapse */
ToggleComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ToggleComponent.propDecorators = {
    checked: [{ type: Input }],
    label: [{ type: Input }],
    disabled: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToggleComponent, [{
        type: Component,
        args: [{
                selector: 'it-toggle',
                template: `<div class="form-check">
  <div class="toggles">
    <label [attr.for]=inputId>
      {{label}}
      <input type=checkbox
        [id]=inputId
        [checked]=checked
        [disabled]=disabled
        (change)=handleChange($event)>
      <span class="lever"></span>
    </label>
  </div>
</div>`,
                styles: [``],
                providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ToggleComponent), multi: true }],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { change: [{
            type: Output
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
class UniqueSelectionDispatcher {
    constructor() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    notify(id, name) {
        for (const listener of this._listeners) {
            listener(id, name);
        }
    }
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    listen(listener) {
        this._listeners.push(listener);
        return () => {
            this._listeners = this._listeners.filter((registered) => {
                return listener !== registered;
            });
        };
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._listeners = [];
    }
}
UniqueSelectionDispatcher.ɵfac = function UniqueSelectionDispatcher_Factory(t) { return new (t || UniqueSelectionDispatcher)(); };
UniqueSelectionDispatcher.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UniqueSelectionDispatcher, factory: UniqueSelectionDispatcher.ɵfac, providedIn: 'root' });
/** @nocollapse */ UniqueSelectionDispatcher.ngInjectableDef = defineInjectable({ factory: function UniqueSelectionDispatcher_Factory() { return new UniqueSelectionDispatcher(); }, token: UniqueSelectionDispatcher, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniqueSelectionDispatcher, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$3 = 0;
/**
 * @param {?} value
 * @return {?}
 */
function _coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}
class RadioChange {
    /**
     * @param {?} source
     * @param {?} value
     */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
class RadioGroupDirective {
    /**
     * @param {?} _changeDetector
     */
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this.role = 'radiogroup';
        /**
         * Il valore selezionato per il gruppo. Dovrebbe essere uguale al valore del radio button selezionato se
         * *esiste* un radio button con un valore corrispondente. Se *non esiste* un radio button corrispondente
         * questo valore persiste ed è applicato nel caso in cui un nuovo radio button viene aggiunto con il valore
         * corrispondente.
         */
        this._value = null;
        /**
         * L'attributo HTML name da applicare ai radio button in questo gruppo
         */
        this._name = `it-radio-group-${identifier$3++}`;
        /**
         * Il radio button attualmente selezionato.
         */
        this._selected = null;
        /**
         * se `value` è stato settato al suo valore iniziale.
         */
        this._isInitialized = false;
        /**
         * Se il radio group è disabilitato.
         */
        this._disabled = false;
        /**
         * Evento emesso quando il valore del gruppo cambia.
         * Gli eventi di change sono emessi soltanto quando il valore cambia a causa dell'interazione dell'utente
         * con il radio button (stesso comportamento di `<input type-"radio">`).
         */
        this.change = new EventEmitter();
        /**
         * Il metodo da chiamare per aggiornare ngModel
         */
        this._controlValueAccessorChangeFn = () => { };
        this.onTouched = () => { };
    }
    /**
     * Nome del gruppo di radio button. Tutti i radio button all'interno del gruppo avranno questo nome.
     * @return {?}
     */
    get name() { return this._name; }
    /**
     * @param {?} value
     * @return {?}
     */
    set name(value) {
        this._name = value;
        this._updateRadioButtonNames();
    }
    /**
     * Valore del radio button.
     * @return {?}
     */
    get value() { return this._value; }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set value(newValue) {
        if (this._value !== newValue) {
            this._value = newValue;
            this._updateSelectedRadioFromValue();
            this._checkSelectedRadioButton();
        }
    }
    /**
     * @return {?}
     */
    _checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    /**
     * Il radio button selezionato.
     * @return {?}
     */
    get selected() { return this._selected; }
    /**
     * @param {?} selected
     * @return {?}
     */
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this._checkSelectedRadioButton();
    }
    /**
     * Se il gruppo è disabled
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this._disabled = _coerceBooleanProperty(value);
        this._markRadiosForCheck();
    }
    /**
     * Inizializza le proprietà quando il contenuto dei figliè disponibile.
     * Questo permette di propagare gli attributi rilevanti ai radio buttons associati.
     * @return {?}
     */
    ngAfterContentInit() {
        this._isInitialized = true;
    }
    /**
     * @return {?}
     */
    _touch() {
        if (this.onTouched) {
            this.onTouched();
        }
    }
    /**
     * @return {?}
     */
    _updateRadioButtonNames() {
        if (this._radios) {
            this._radios.forEach(radio => {
                radio.name = this.name;
            });
        }
    }
    /**
     * Aggiorna il radio button `selected` a seconda del suo _value.
     * @return {?}
     */
    _updateSelectedRadioFromValue() {
        this._selected = null;
        this._radios.forEach(radio => {
            radio.checked = this.value === radio.value;
            if (radio.checked) {
                this._selected = radio;
            }
        });
    }
    /**
     * Invia l'evento change con la selezione corrente e il valore del gruppo.
     * @return {?}
     */
    _emitChangeEvent() {
        if (this._isInitialized) {
            this.change.emit(new RadioChange(this._selected, this._value));
        }
    }
    /**
     * @return {?}
     */
    _markRadiosForCheck() {
        if (this._radios) {
            this._radios.forEach(radio => radio._markForCheck());
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.value = value;
        this._changeDetector.markForCheck();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
RadioGroupDirective.ɵfac = function RadioGroupDirective_Factory(t) { return new (t || RadioGroupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
RadioGroupDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RadioGroupDirective, selectors: [["it-radio-group"]], contentQueries: function RadioGroupDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, RadioButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._radios = _t);
    } }, hostVars: 1, hostBindings: function RadioGroupDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { name: "name", value: "value", selected: "selected", disabled: "disabled" }, outputs: { change: "change" }, exportAs: ["itRadioGroup"], features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioGroupDirective),
                multi: true
            }])] });
/** @nocollapse */
RadioGroupDirective.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
RadioGroupDirective.propDecorators = {
    role: [{ type: HostBinding, args: ['attr.role',] }],
    change: [{ type: Output }],
    _radios: [{ type: ContentChildren, args: [forwardRef(() => RadioButtonComponent), { descendants: true },] }],
    name: [{ type: Input }],
    value: [{ type: Input }],
    selected: [{ type: Input }],
    disabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupDirective, [{
        type: Directive,
        args: [{
                selector: 'it-radio-group',
                // tslint:disable-line
                exportAs: 'itRadioGroup',
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioGroupDirective),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], change: [{
            type: Output
        }], name: [{
            type: Input
        }], value: [{
            type: Input
        }], selected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], _radios: [{
            type: ContentChildren,
            args: [forwardRef(() => RadioButtonComponent), { descendants: true }]
        }] }); })();
/**
 * Un radio button con design bootstrap italia. Supporta tutte le funzionalità di una radio HTML5,
 * ed espone una API simile. Una `<it-radio-button>` può essere checked, unchecked, o disabled.
 */
class RadioButtonComponent {
    /**
     * @param {?} radioGroup
     * @param {?} _changeDetector
     * @param {?} _radioDispatcher
     */
    constructor(radioGroup, _changeDetector, _radioDispatcher) {
        this._changeDetector = _changeDetector;
        this._radioDispatcher = _radioDispatcher;
        this.id = `radio-${identifier$3++}`;
        /**
         * Evento emesso quando il valore `checked` del radio button cambia.
         */
        this.change = new EventEmitter();
        /**
         * Se il radio button è checked.
         */
        this._checked = false;
        /**
         * il valore assegnato al radio button.
         */
        this._value = null;
        this._removeUniqueSelectionListener = () => { };
        this.radioGroup = radioGroup;
        this._removeUniqueSelectionListener =
            _radioDispatcher.listen((id, name) => {
                if (id !== this.id && name === this.name) {
                    this.checked = false;
                }
            });
    }
    /**
     * se il radio button è checked.
     * @return {?}
     */
    get checked() { return this._checked; }
    /**
     * @param {?} value
     * @return {?}
     */
    set checked(value) {
        /** @type {?} */
        const newCheckedState = _coerceBooleanProperty(value);
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
            if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                this.radioGroup.selected = this;
            }
            else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                this.radioGroup.selected = null;
            }
            if (newCheckedState) {
                this._radioDispatcher.notify(this.id, this.name);
            }
            this._changeDetector.markForCheck();
        }
    }
    /**
     * Il valore di questo radio button.
     * @return {?}
     */
    get value() { return this._value; }
    /**
     * @param {?} value
     * @return {?}
     */
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            if (this.radioGroup !== null) {
                if (!this.checked) {
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        }
    }
    /**
     * Se il radio button è disabled.
     * @return {?}
     */
    get disabled() {
        return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        /** @type {?} */
        const newDisabledState = !!value;
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
            this._changeDetector.markForCheck();
        }
    }
    /**
     * Segna il radio button come da controllare per la change detection.
     * @return {?}
     */
    _markForCheck() {
        this._changeDetector.markForCheck();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.radioGroup) {
            // Se il radio button è all'interno di un gruppo, determina se deve essere selezionato
            this.checked = this.radioGroup.value === this._value;
            // Copia il `name` del radio group
            this.name = this.radioGroup.name;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._removeUniqueSelectionListener();
    }
    /**
     * @return {?}
     */
    _emitChangeEvent() {
        this.change.emit(new RadioChange(this, this._value));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    _onInputChange(event) {
        event.stopPropagation();
        /** @type {?} */
        const groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
        this.checked = true;
        this._emitChangeEvent();
        if (this.radioGroup) {
            this.radioGroup._controlValueAccessorChangeFn(this.value);
            this.radioGroup._touch();
            if (groupValueChanged) {
                this.radioGroup._emitChangeEvent();
            }
        }
    }
}
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(ɵngcc0.ɵɵdirectiveInject(RadioGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(UniqueSelectionDispatcher)); };
RadioButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["it-radio-button"]], inputs: { checked: "checked", value: "value", disabled: "disabled", name: "name", label: "label" }, outputs: { change: "change" }, exportAs: ["itRadioButton"], decls: 4, vars: 6, consts: [[1, "form-check"], ["type", "radio", 3, "id", "checked", "disabled", "change"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        ɵngcc0.ɵɵlistener("change", function RadioButtonComponent_Template_input_change_1_listener($event) { return ctx._onInputChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("checked", ctx.checked)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("name", ctx.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("for", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, styles: [""], changeDetection: 0 });
/** @nocollapse */
RadioButtonComponent.ctorParameters = () => [
    { type: RadioGroupDirective, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef },
    { type: UniqueSelectionDispatcher }
];
RadioButtonComponent.propDecorators = {
    name: [{ type: Input }],
    label: [{ type: Input }],
    checked: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'it-radio-button',
                template: `<div class="form-check">
  <input type="radio"
    [id]="id"
    [checked]="checked"
    [disabled]="disabled"
    [attr.name]="name"
    (change)="_onInputChange($event)">
  <label
    [attr.for]="id">{{label}}</label>
</div>
`,
                styles: [``],
                exportAs: 'itRadioButton',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: RadioGroupDirective, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: UniqueSelectionDispatcher }]; }, { change: [{
            type: Output
        }], checked: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright Angular ng-bootstrap team All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/ng-bootstrap/ng-bootstrap/master/LICENSE
 */
class Trigger$1 {
    /**
     * @param {?} open
     * @param {?=} close
     */
    constructor(open, close) {
        this.open = open;
        this.close = close;
        if (!close) {
            this.close = open;
        }
    }
    /**
     * @return {?}
     */
    isManual() { return this.open === 'manual' || this.close === 'manual'; }
}
/** @type {?} */
const DEFAULT_ALIASES$1 = {
    'hover': ['mouseenter', 'mouseleave'],
    'focus': ['focus', 'blur']
};
/**
 * @param {?} triggers
 * @param {?=} aliases
 * @return {?}
 */
function parseTriggers$1(triggers, aliases = DEFAULT_ALIASES$1) {
    /** @type {?} */
    const trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    /** @type {?} */
    const parsedTriggers = trimmedTriggers.split(/\s+/).map(trigger => trigger.split(':')).map((triggerPair) => {
        /** @type {?} */
        const alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger$1(alias[0], alias[1]);
    });
    /** @type {?} */
    const manualTriggers = parsedTriggers.filter(triggerPair => triggerPair.isManual());
    if (manualTriggers.length > 1) {
        throw new Error('Triggers parse error: only one manual trigger is allowed');
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw new Error('Triggers parse error: manual trigger can\'t be mixed with other triggers');
    }
    return parsedTriggers;
}
/** @type {?} */
const noopFn$1 = () => { };
/**
 * @param {?} renderer
 * @param {?} nativeElement
 * @param {?} triggers
 * @param {?} openFn
 * @param {?} closeFn
 * @param {?} toggleFn
 * @return {?}
 */
function listenToTriggers$1(renderer, nativeElement, triggers, openFn, closeFn, toggleFn) {
    /** @type {?} */
    const parsedTriggers = parseTriggers$1(triggers);
    /** @type {?} */
    const listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return noopFn$1;
    }
    parsedTriggers.forEach((trigger) => {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(nativeElement, trigger.open, toggleFn));
        }
        else {
            listeners.push(renderer.listen(nativeElement, trigger.open, openFn), renderer.listen(nativeElement, trigger.close, closeFn));
        }
    });
    return () => { listeners.forEach(unsubscribeFn => unsubscribeFn()); };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright Angular ng-bootstrap team All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/ng-bootstrap/ng-bootstrap/master/LICENSE
 */
class Positioning$1 {
    /**
     * @param {?} element
     * @return {?}
     */
    getAllStyles(element) { return window.getComputedStyle(element); }
    /**
     * @param {?} element
     * @param {?} prop
     * @return {?}
     */
    getStyle(element, prop) { return this.getAllStyles(element)[prop]; }
    /**
     * @param {?} element
     * @return {?}
     */
    isStaticPositioned(element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    }
    /**
     * @param {?} element
     * @return {?}
     */
    offsetParent(element) {
        /** @type {?} */
        let offsetParentEl = /** @type {?} */ (element.offsetParent) || document.documentElement;
        while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = /** @type {?} */ (offsetParentEl.offsetParent);
        }
        return offsetParentEl || document.documentElement;
    }
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    position(element, round = true) {
        /** @type {?} */
        let elPosition;
        /** @type {?} */
        let parentOffset = { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
        if (this.getStyle(element, 'position') === 'fixed') {
            elPosition = element.getBoundingClientRect();
        }
        else {
            /** @type {?} */
            const offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    }
    /**
     * @param {?} element
     * @param {?=} round
     * @return {?}
     */
    offset(element, round = true) {
        /** @type {?} */
        const elBcr = element.getBoundingClientRect();
        /** @type {?} */
        const viewportOffset = {
            top: window.pageYOffset - document.documentElement.clientTop,
            left: window.pageXOffset - document.documentElement.clientLeft
        };
        /** @type {?} */
        const elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    }
    /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @param {?} placement
     * @param {?=} appendToBody
     * @return {?}
     */
    positionElements(hostElement, targetElement, placement, appendToBody) {
        /** @type {?} */
        const hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
        /** @type {?} */
        const targetElStyles = this.getAllStyles(targetElement);
        /** @type {?} */
        const targetElBCR = targetElement.getBoundingClientRect();
        /** @type {?} */
        const placementPrimary = placement.split('-')[0] || 'top';
        /** @type {?} */
        const placementSecondary = placement.split('-')[1] || 'center';
        /** @type {?} */
        const targetElPosition = {
            'height': targetElBCR.height || targetElement.offsetHeight,
            'width': targetElBCR.width || targetElement.offsetWidth,
            'top': 0,
            'bottom': targetElBCR.height || targetElement.offsetHeight,
            'left': 0,
            'right': targetElBCR.width || targetElement.offsetWidth
        };
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top =
                    hostElPosition.top - (targetElement.offsetHeight + parseFloat(targetElStyles.marginBottom));
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height;
                break;
            case 'left':
                targetElPosition.left =
                    hostElPosition.left - (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width;
                break;
        }
        switch (placementSecondary) {
            case 'top':
                targetElPosition.top = hostElPosition.top;
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left;
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
                break;
            case 'center':
                if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                    targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
                }
                else {
                    targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
                }
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    }
    /**
     * @param {?} hostElement
     * @param {?} targetElement
     * @return {?}
     */
    getAvailablePlacements(hostElement, targetElement) {
        /** @type {?} */
        const availablePlacements = [];
        /** @type {?} */
        const hostElemClientRect = hostElement.getBoundingClientRect();
        /** @type {?} */
        const targetElemClientRect = targetElement.getBoundingClientRect();
        /** @type {?} */
        const html = document.documentElement;
        /** @type {?} */
        const windowHeight = window.innerHeight || html.clientHeight;
        /** @type {?} */
        const windowWidth = window.innerWidth || html.clientWidth;
        /** @type {?} */
        const hostElemClientRectHorCenter = hostElemClientRect.left + hostElemClientRect.width / 2;
        /** @type {?} */
        const hostElemClientRectVerCenter = hostElemClientRect.top + hostElemClientRect.height / 2;
        // controlla se la larghezza dell'elemento target può essere collocata tra la sinistra dell'host e l'inizio della viewport
        // e controlla anche se l'altezza del target è nella viewport
        if (targetElemClientRect.width < hostElemClientRect.left) {
            // controlla solo per la sinistra
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'left');
            }
            // controlla solo per le varianti di sinistra left-top and left-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'left', availablePlacements);
        }
        // controlla se l'altezza del target è minore della cima dell'host
        if (targetElemClientRect.height < hostElemClientRect.top) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'top');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'top', availablePlacements);
        }
        // controlla se la larghezza dell'elemento target può essere collocata tra la destra dell'host e la fine della viewport
        // e controlla anche se l'altezza del target è nella viewport
        if (windowWidth - hostElemClientRect.right > targetElemClientRect.width) {
            // controlla solo per la destra
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'right');
            }
            // controlla solo per le varianti di destra right-top and right-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'right', availablePlacements);
        }
        // controlla se c'è abbastanza spazio tra la base dell'host e la fine della viewport per l'altezza del target
        if (windowHeight - hostElemClientRect.bottom > targetElemClientRect.height) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'bottom');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'bottom', availablePlacements);
        }
        return availablePlacements;
    }
    /**
     * Controlla se il collocamento secondario per sinistra e destra è disponibile, come left-top, left-bottom, right-top e right-bottom
     * primaryplacement: left|right
     * availablePlacementArr: array con i collocamenti disponibili
     * @param {?} hostElemClientRect
     * @param {?} targetElemClientRect
     * @param {?} primaryPlacement
     * @param {?} availablePlacementArr
     * @return {?}
     */
    setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        /** @type {?} */
        const html = document.documentElement;
        // check for left-bottom
        if (targetElemClientRect.height <= hostElemClientRect.bottom) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-bottom');
        }
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.top >= targetElemClientRect.height) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-top');
        }
    }
    /**
     * Controlla se il collocamento secondario per sopra e sotto è disponibile, come top-left, top-right, bottom-left, bottom-right
     * primaryplacement: top|bottom
     * availablePlacementArr: array con i collocamenti disponibili
     * @param {?} hostElemClientRect
     * @param {?} targetElemClientRect
     * @param {?} primaryPlacement
     * @param {?} availablePlacementArr
     * @return {?}
     */
    setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        /** @type {?} */
        const html = document.documentElement;
        // check for left-bottom
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.left >= targetElemClientRect.width) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-left');
        }
        if (targetElemClientRect.width <= hostElemClientRect.right) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-right');
        }
    }
}
/** @type {?} */
const positionService$1 = new Positioning$1();
/**
 * @param {?} hostElement
 * @param {?} targetElement
 * @param {?} placement
 * @param {?=} appendToBody
 * @return {?}
 */
function positionElements$1(hostElement, targetElement, placement, appendToBody) {
    /** @type {?} */
    const placementVals = Array.isArray(placement) ? placement : [/** @type {?} */ (placement)];
    /** @type {?} */
    let hasAuto = placementVals.findIndex(val => val === 'auto');
    if (hasAuto >= 0) {
        ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top',
            'left-bottom', 'right-top', 'right-bottom',
        ].forEach(function (obj) {
            if (placementVals.find(val => val.search('^' + obj) !== -1) == null) {
                placementVals.splice(hasAuto++, 1, /** @type {?} */ (obj));
            }
        });
    }
    /** @type {?} */
    let topVal = 0;
    /** @type {?} */
    let leftVal = 0;
    /** @type {?} */
    let appliedPlacement;
    /** @type {?} */
    const availablePlacements = positionService$1.getAvailablePlacements(hostElement, targetElement);
    // iterare sui collocamenti acquisiti
    for (const { item, index } of toItemIndexes$1(placementVals)) {
        // Controlla se il collocamento passato è presente nel collocamento disponibile, altrimenti applica l'ultimo collocamento nella
        // lista del collocamento passato
        if ((availablePlacements.find(val => val === item) != null) || (placementVals.length === index + 1)) {
            appliedPlacement = /** @type {?} */ (item);
            /** @type {?} */
            const pos = positionService$1.positionElements(hostElement, targetElement, item, appendToBody);
            topVal = pos.top;
            leftVal = pos.left;
            break;
        }
    }
    targetElement.style.top = `${topVal}px`;
    targetElement.style.left = `${leftVal}px`;
    return appliedPlacement;
}
/**
 * @template T
 * @param {?} a
 * @return {?}
 */
function toItemIndexes$1(a) {
    return a.map((item, index) => ({ item, index }));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ContentRef$1 {
    /**
     * @param {?} nodes
     * @param {?=} viewRef
     * @param {?=} componentRef
     */
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
/**
 * @template T
 */
class PopupService$1 {
    /**
     * @param {?} _type
     * @param {?} _injector
     * @param {?} _viewContainerRef
     * @param {?} _renderer
     * @param {?} _componentFactoryResolver
     */
    constructor(_type, _injector, _viewContainerRef, _renderer, _componentFactoryResolver) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._componentFactoryResolver = _componentFactoryResolver;
    }
    /**
     * @param {?=} content
     * @param {?=} context
     * @return {?}
     */
    open(content, context) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), 0, this._injector, this._contentRef.nodes);
        }
        return this._windowRef;
    }
    /**
     * @return {?}
     */
    close() {
        if (this._windowRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
            this._windowRef = null;
            if (this._contentRef.viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
                this._contentRef = null;
            }
        }
    }
    /**
     * @param {?} content
     * @param {?=} context
     * @return {?}
     */
    _getContentRef(content, context) {
        if (!content) {
            return new ContentRef$1([]);
        }
        else if (content instanceof TemplateRef) {
            /** @type {?} */
            const viewRef = this._viewContainerRef.createEmbeddedView(/** @type {?} */ (content), context);
            return new ContentRef$1([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef$1([[this._renderer.createText(`${content}`)]]);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Servizio di configurazione per la direttiva Ittooltip.
 * Il servizio può essere iniettato, tipicamente in un root component, per impostare i valori delle proprietà in
 * modo tale da fornire i valori di default per tutti i tooltip utilizzati in un'applicazione.
 */
class TooltipConfig {
    constructor() {
        this.placement = 'right';
        this.disableTooltip = false;
    }
}
TooltipConfig.ɵfac = function TooltipConfig_Factory(t) { return new (t || TooltipConfig)(); };
TooltipConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TooltipConfig, factory: TooltipConfig.ɵfac, providedIn: 'root' });
/** @nocollapse */ TooltipConfig.ngInjectableDef = defineInjectable({ factory: function TooltipConfig_Factory() { return new TooltipConfig(); }, token: TooltipConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class TooltipComponent {
    /**
     * @param {?} _element
     * @param {?} _renderer
     */
    constructor(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.placement = 'right';
        this.hidden = false;
        this.role = 'tooltip';
    }
    /**
     * @return {?}
     */
    get myCssClass() {
        return 'tooltip show bs-tooltip-' + this.placement.split('-')[0] + ' bs-tooltip-' + this.placement;
    }
    /**
     * @param {?} _placement
     * @return {?}
     */
    applyPlacement(_placement) {
        // Rimuovi le classi della posizione precedente
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
        // Imposta la nuova posizione
        this.placement = _placement;
        // Applica le classi della nuova posizione
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
    }
}
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
TooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["it-tooltip-window"]], hostVars: 5, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("hidden", ctx.hidden)("id", ctx.id);
        ɵngcc0.ɵɵattribute("role", ctx.role);
        ɵngcc0.ɵɵclassMap(ctx.myCssClass);
    } }, inputs: { placement: "placement", hidden: "hidden", id: "id" }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "arrow"], [1, "tooltip-inner"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".bs-tooltip-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:calc(50% - .4rem)}.bs-tooltip-bottom-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-top-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:1em}.bs-tooltip-bottom-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-top-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{left:auto;right:.8rem}.bs-tooltip-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:calc(50% - .4rem)}.bs-tooltip-left-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:.4rem}.bs-tooltip-left-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%]{top:auto;bottom:.4rem}"], changeDetection: 0 });
/** @nocollapse */
TooltipComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
TooltipComponent.propDecorators = {
    placement: [{ type: Input }],
    id: [{ type: Input }, { type: HostBinding, args: ['id',] }],
    hidden: [{ type: Input }, { type: HostBinding, args: ['hidden',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    myCssClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'it-tooltip-window',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `<div class="arrow"></div>
<div class="tooltip-inner">
  <ng-content></ng-content>
</div>`,
                styles: [`:host.bs-tooltip-bottom .arrow,:host.bs-tooltip-top .arrow{left:calc(50% - .4rem)}:host.bs-tooltip-bottom-left .arrow,:host.bs-tooltip-top-left .arrow{left:1em}:host.bs-tooltip-bottom-right .arrow,:host.bs-tooltip-top-right .arrow{left:auto;right:.8rem}:host.bs-tooltip-left .arrow,:host.bs-tooltip-right .arrow{top:calc(50% - .4rem)}:host.bs-tooltip-left-top .arrow,:host.bs-tooltip-right-top .arrow{top:.4rem}:host.bs-tooltip-left-bottom .arrow,:host.bs-tooltip-right-bottom .arrow{top:auto;bottom:.4rem}`]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { placement: [{
            type: Input
        }], hidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['hidden']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], myCssClass: [{
            type: HostBinding,
            args: ['class']
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['id']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const TRIGGER = INTERACTION_TRIGGERS.HOVER;
/** @type {?} */
let identifier$4 = 0;
/**
 * Una direttiva per la creazione di un tooltip.
 */
class TooltipDirective {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} injector
     * @param {?} componentFactoryResolver
     * @param {?} viewContainerRef
     * @param {?} config
     * @param {?} ngZone
     */
    constructor(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._showEvent = new EventEmitter();
        this._shownEvent = new EventEmitter();
        this._insertedEvent = new EventEmitter();
        this._hideEvent = new EventEmitter();
        this._hiddenEvent = new EventEmitter();
        this._disableTooltip = false;
        this._itTooltipWindowId = `it-tooltip-${identifier$4++}`;
        this.placement = config.placement;
        this.container = config.container;
        this.disableTooltip = config.disableTooltip;
        this._popupService = new PopupService$1(TooltipComponent, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(() => {
            if (this._windowRef) {
                this._windowRef.instance.applyPlacement(positionElements$1(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            }
        });
    }
    /**
     * Contenuto da mostrare nel tooltip. In assenza di contenuto, il tooltip non si aprirà.
     * @return {?}
     */
    get itTooltip() { return this._itTooltip; }
    /**
     * @param {?} value
     * @return {?}
     */
    set itTooltip(value) { this._itTooltip = value; }
    /**
     * Il collocamento accettato dal tooltip:
     *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
     *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
     * ed array dei valori soprariportati.
     * @return {?}
     */
    get placement() { return this._placement; }
    /**
     * @param {?} value
     * @return {?}
     */
    set placement(value) { this._placement = value; }
    /**
     * Un selettore che specifica l'elemento in cui il tooltip dovrebbe essere aggiunto.
     * Attualmente supporta solo "body".
     * @return {?}
     */
    get container() { return this._container; }
    /**
     * @param {?} value
     * @return {?}
     */
    set container(value) { this._container = value; }
    /**
     * Evento da emettere quando il tooltip sta per essere mostrato
     * @return {?}
     */
    get showEvent() { return this._showEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set showEvent(value) { this._showEvent = value; }
    /**
     * Evento da emettere quando il tooltip è mostrato
     * @return {?}
     */
    get shownEvent() { return this._shownEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set shownEvent(value) { this._shownEvent = value; }
    /**
     * Evento da emettere quando il tooltip viene inserito nel DOM
     * @return {?}
     */
    get insertedEvent() { return this._insertedEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set insertedEvent(value) { this._insertedEvent = value; }
    /**
     * Evento da emettere quando il tooltip sta per essere nascosto
     * @return {?}
     */
    get hideEvent() { return this._hideEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hideEvent(value) { this._hideEvent = value; }
    /**
     * Evento da emettere quando il tooltip è nascosto
     * @return {?}
     */
    get hiddenEvent() { return this._hiddenEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hiddenEvent(value) { this._hiddenEvent = value; }
    /**
     * Un flag utilizzato per indicare se un tooltip è disabilitato, così da non doverlo mostrare.
     * @return {?}
     */
    get disableTooltip() { return this._disableTooltip; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disableTooltip(value) { this._disableTooltip = Util.coerceBooleanProperty(value); }
    /**
     * @return {?}
     */
    _isDisabled() {
        if (this.disableTooltip) {
            return true;
        }
        if (!this.itTooltip) {
            return true;
        }
        return false;
    }
    /**
     * Apre il tooltip di un elemento. È considerato un azionamento "manuale" del tooltip.
     * Il context è un valore opzionale da iniettare nel template del tooltip quando esso viene creato.
     * @param {?=} context
     * @return {?}
     */
    show(context) {
        if (!this._isDisabled()) {
            // Scatena l'evento per segnalare l'inizio del processo per visualizzare il tooltip
            this.showEvent.emit(this);
            if (!this._windowRef) {
                this._windowRef = this._popupService.open(this.itTooltip, context);
                /** @type {?} */
                const tooltipComponent = this._windowRef.instance;
                tooltipComponent.id = this._itTooltipWindowId;
                this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._itTooltipWindowId);
                if (this.container === 'body') {
                    window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
                }
                this._windowRef.changeDetectorRef.detectChanges();
                this._windowRef.changeDetectorRef.markForCheck();
                // Posiziona il tooltip attorno all'elemento
                tooltipComponent.applyPlacement(positionElements$1(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
                // Scatena l'evento per segnalare l'inserimento nel DOM
                this.insertedEvent.emit(this);
            }
            else {
                /** @type {?} */
                const tooltipComponent = this._windowRef.instance;
                tooltipComponent.hidden = false;
            }
            // Scatena l'evento per segnalare che il tooltip è stato visualizzato
            this.shownEvent.emit(this);
        }
    }
    /**
     * Chiude il tooltip di un elemento. È considerato un azionamento "manuale" del tooltip.
     * @return {?}
     */
    hide() {
        // Scatena l'evento per segnalare l'inizio del processo per nascondere il tooltip
        this.hideEvent.emit(this);
        if (this._windowRef) {
            /** @type {?} */
            const tooltipComponent = this._windowRef.instance;
            tooltipComponent.hidden = true;
            // Scatena l'evento per segnalare che il tooltip è stato nascosto
            this.hiddenEvent.emit(this);
        }
    }
    /**
     * Apre/chiude il un tooltip di un elemento. È considerato un azionamento "manuale" del tooltip.
     * @return {?}
     */
    toggle() {
        if (this._windowRef) {
            if (this._windowRef.instance.hidden) {
                this.show();
            }
            else {
                this.hide();
            }
        }
        else {
            this.show();
        }
    }
    /**
     * Nasconde e distrugge il tooltip di un elemento.
     * @return {?}
     */
    dispose() {
        /** @type {?} */
        const isShown = this._windowRef ? !this._windowRef.instance.hidden : false;
        if (isShown) {
            this.hide();
        }
        if (this._windowRef) {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
            this._popupService.close();
            this._windowRef = null;
        }
    }
    /**
     * Fornisce al tooltip di un elemento la possibilità di essere mostrato.
     * @return {?}
     */
    enable() {
        if (this._isDisabled()) {
            this.disableTooltip = false;
        }
    }
    /**
     * Rimuove la capacità di mostrare il tooltip di un elemento.
     * @return {?}
     */
    disable() {
        if (!this._isDisabled()) {
            this.disableTooltip = true;
        }
    }
    /**
     * Attiva/disattiva la possibilità che il tooltip di un elemento sia mostrato o nascosto.
     * @return {?}
     */
    toggleEnabled() {
        if (this._isDisabled()) {
            this.enable();
        }
        else {
            this.disable();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._unregisterListenersFn = listenToTriggers$1(this._renderer, this._elementRef.nativeElement, TRIGGER, this.show.bind(this), this.hide.bind(this), this.toggle.bind(this));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        // Chiude il tooltip se il contenuto risulta vuoto, o se disableTooltip è impostato a vero
        if ((changes['itTooltip'] || changes['disableTooltip']) && this._isDisabled()) {
            this.hide();
        }
        else if (changes['placement']) {
            if (this._windowRef) {
                this._windowRef.instance.applyPlacement(positionElements$1(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
            }
        }
        else if (changes['container']) {
            /** @type {?} */
            const isShown = this._windowRef ? !this._windowRef.instance.hidden : false;
            this.dispose();
            if (isShown) {
                this.show();
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.dispose();
        this._unregisterListenersFn();
        this._zoneSubscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    handleFocus() {
        this.show();
    }
    /**
     * @return {?}
     */
    handleBlur() {
        this.hide();
    }
}
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(TooltipConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "it-tooltip", ""]], hostBindings: function TooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function TooltipDirective_focus_HostBindingHandler() { return ctx.handleFocus(); })("blur", function TooltipDirective_blur_HostBindingHandler() { return ctx.handleBlur(); });
    } }, inputs: { placement: "placement", container: "container", disableTooltip: ["disabled", "disableTooltip"], itTooltip: ["it-tooltip", "itTooltip"] }, outputs: { showEvent: "show", shownEvent: "shown", insertedEvent: "inserted", hideEvent: "hide", hiddenEvent: "hidden" }, exportAs: ["it-tooltip"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
TooltipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: Injector },
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef },
    { type: TooltipConfig },
    { type: NgZone }
];
TooltipDirective.propDecorators = {
    itTooltip: [{ type: Input, args: ['it-tooltip',] }],
    placement: [{ type: Input }],
    container: [{ type: Input }],
    showEvent: [{ type: Output, args: ['show',] }],
    shownEvent: [{ type: Output, args: ['shown',] }],
    insertedEvent: [{ type: Output, args: ['inserted',] }],
    hideEvent: [{ type: Output, args: ['hide',] }],
    hiddenEvent: [{ type: Output, args: ['hidden',] }],
    disableTooltip: [{ type: Input, args: ['disabled',] }],
    handleFocus: [{ type: HostListener, args: ['focus',] }],
    handleBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[it-tooltip]',
                // tslint:disable-line
                exportAs: 'it-tooltip'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: TooltipConfig }, { type: ɵngcc0.NgZone }]; }, { placement: [{
            type: Input
        }], container: [{
            type: Input
        }], disableTooltip: [{
            type: Input,
            args: ['disabled']
        }], itTooltip: [{
            type: Input,
            args: ['it-tooltip']
        }], showEvent: [{
            type: Output,
            args: ['show']
        }], shownEvent: [{
            type: Output,
            args: ['shown']
        }], insertedEvent: [{
            type: Output,
            args: ['inserted']
        }], hideEvent: [{
            type: Output,
            args: ['hide']
        }], hiddenEvent: [{
            type: Output,
            args: ['hidden']
        }], 
    /**
     * @return {?}
     */
    handleFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /**
     * @return {?}
     */
    handleBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const ButtonSize = keyof({
    lg: null,
    sm: null,
    xs: null,
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$5 = 0;
/**
 * Un bottone con design bootstrap italia. Supporta tutte le funzionalità di un bottone HTML5.
 */
class ButtonComponent {
    constructor() {
        this.id = `button-${identifier$5++}`;
        this._disabled = false;
        this._outline = false;
        this._block = false;
    }
    /**
     * Se presente, il pulsante avrà un effetto di trasparenza e non reagirà al click
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) { this._disabled = Util.coerceBooleanProperty(value); }
    /**
     * Stabilisce se lo stile del pulsante avrà un contorno.
     * Accetta una espressione booleana o può essere usato come attributo senza valore.
     * Deve funzionare solo in congiunzione con un colore definito, altrimenti l'attributo viene ignorato.
     * @return {?}
     */
    get outline() { return this._outline; }
    /**
     * @param {?} value
     * @return {?}
     */
    set outline(value) { this._outline = Util.coerceBooleanProperty(value); }
    /**
     * Indica se il pulsante occupa tutta l'ampiezza a sua disposizione.
     * @return {?}
     */
    get block() { return this._block; }
    /**
     * @param {?} value
     * @return {?}
     */
    set block(value) { this._block = Util.coerceBooleanProperty(value); }
    /**
     * Stabilisce il colore del pulsante a seconda delle classi di bootstrap.
     * Può avere valori:
     * <ul>
     * <li> primary
     * <li> secondary
     * <li> danger
     * <li> warning
     * <li> info
     * <li> success
     * <li> light
     * <li> dark
     * </ul>
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set color(value) {
        if (ThemeColor.is(value)) {
            this._color = value;
        }
        else {
            this._color = undefined;
        }
    }
    /**
     * Indica la grandezza del pulsante. Può assumere i valori:
     * <ul>
     * <li> lg
     * <li> sm
     * <li> xs
     * </ul>
     * @return {?}
     */
    get size() {
        return this._size;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set size(value) {
        if (ButtonSize.is(value)) {
            this._size = value;
        }
        else {
            this._size = undefined;
        }
    }
    /**
     * @return {?}
     */
    get buttonClass() {
        /** @type {?} */
        let cssClass = 'btn';
        if (this.color) {
            if (this.outline) {
                cssClass += ` btn-outline-${this.color}`;
            }
            else {
                cssClass += ` btn-${this.color}`;
            }
        }
        if (this.size) {
            cssClass += ` btn-${this.size}`;
        }
        if (this.block) {
            cssClass += ' btn-block';
        }
        if (this.disabled) {
            cssClass += ' disabled';
        }
        return cssClass;
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["it-button"]], inputs: { disabled: "disabled", outline: "outline", block: "block", color: "color", size: "size" }, ngContentSelectors: _c1, decls: 2, vars: 5, consts: [["type", "button", 3, "id", "disabled"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.buttonClass);
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.disabled);
    } }, styles: [""] });
ButtonComponent.propDecorators = {
    disabled: [{ type: Input }],
    outline: [{ type: Input }],
    block: [{ type: Input }],
    color: [{ type: Input }],
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'it-button',
                template: `<button type="button" [id]="id" [class]="buttonClass" [disabled]="disabled" [attr.aria-disabled]="disabled">
  <ng-content></ng-content>
</button>
`,
                styles: [``]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], outline: [{
            type: Input
        }], block: [{
            type: Input
        }], color: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Una badge con design bootstrap italia.
 */
class BadgeDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this._badgeColor = THEME_COLORS.LIGHT;
        this._badgeText = '';
        this._isPill = false;
    }
    /**
     * (Opzionale) indica il colore del badge. Può essere `primary`, `secondary`, `danger`, `warning`, `info`, `success`, `light` o `dark`.
     * Se non viene fornito o il valore è diverso da quelli previsti il suo valore di default è `light`.
     * @return {?}
     */
    get badgeColor() {
        return this._badgeColor;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set badgeColor(value) {
        if (ThemeColor.is(value)) {
            this._badgeColor = value;
        }
        else {
            this._badgeColor = THEME_COLORS.LIGHT;
        }
    }
    /**
     * La direttiva che abilita l'elemento come badge. Mostra il testo come contenuto del badge.
     * Se valutato ad `undefined`, `null` o stringa vuota il badge non viene mostrato.
     * @return {?}
     */
    get badgeText() { return this._badgeText; }
    /**
     * @param {?} value
     * @return {?}
     */
    set badgeText(value) {
        if (value) {
            this._badgeText = value;
        }
        else {
            this._badgeText = '';
        }
    }
    /**
     * Indica se il badge è arrotondato o meno.
     * @return {?}
     */
    get isPill() { return this._isPill; }
    /**
     * @param {?} value
     * @return {?}
     */
    set isPill(value) {
        this._isPill = Util.coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    getBadgeColorClassName() {
        return `badge-${this._badgeColor}`;
    }
    /**
     * @return {?}
     */
    get hostClasses() {
        return [
            'badge',
            this.getBadgeColorClassName(),
            this.isPill ? 'badge-pill' : '',
        ].join(' ');
    }
}
BadgeDirective.ɵfac = function BadgeDirective_Factory(t) { return new (t || BadgeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BadgeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BadgeDirective, selectors: [["", "it-badge", ""]], hostVars: 3, hostBindings: function BadgeDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("innerText", ctx.badgeText);
        ɵngcc0.ɵɵclassMap(ctx.hostClasses);
    } }, inputs: { badgeColor: "badgeColor", badgeText: ["it-badge", "badgeText"], isPill: "isPill" }, exportAs: ["itBadge"] });
/** @nocollapse */
BadgeDirective.ctorParameters = () => [
    { type: ElementRef }
];
BadgeDirective.propDecorators = {
    badgeColor: [{ type: Input }],
    badgeText: [{ type: Input, args: ['it-badge',] }, { type: HostBinding, args: ['innerText',] }],
    isPill: [{ type: Input }],
    hostClasses: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeDirective, [{
        type: Directive,
        args: [{
                selector: '[it-badge]',
                // tslint:disable-line
                exportAs: 'itBadge'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { badgeColor: [{
            type: Input
        }], badgeText: [{
            type: Input,
            args: ['it-badge']
        }, {
            type: HostBinding,
            args: ['innerText']
        }], isPill: [{
            type: Input
        }], hostClasses: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Per ottimizzare l’ingombro dei contenuti di una pagina si possono usare degli elementi richiudibili
 * (in gergo definiti collassabili o collapse), che possono essere attivati indipendentemente l’uno dall’altro
 */
class CollapseDirective {
    constructor() {
        this._isDisposed = false;
        this._isShown = false;
        this._showEvent = new EventEmitter();
        this._shownEvent = new EventEmitter();
        this._hideEvent = new EventEmitter();
        this._hiddenEvent = new EventEmitter();
    }
    /**
     * La direttiva di collapse che opzionalmente contiene il predicato che ne stabilisce
     * che sarà avvalorato a true quando il collapse è espanso, a false altrimenti
     * @return {?}
     */
    get itCollapse() { return this._isShown; }
    /**
     * @param {?} value
     * @return {?}
     */
    set itCollapse(value) { this._isShown = value != null && `${value}` === 'true'; }
    /**
     * Evento da emettere quando il collapse sta per essere mostrato
     * @return {?}
     */
    get showEvent() { return this._showEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set showEvent(value) { this._showEvent = value; }
    /**
     * Evento da emettere quando il collapse è mostrato
     * @return {?}
     */
    get shownEvent() { return this._shownEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set shownEvent(value) { this._shownEvent = value; }
    /**
     * Evento da emettere quando il collapse sta per essere nascosto
     * @return {?}
     */
    get hideEvent() { return this._hideEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hideEvent(value) { this._hideEvent = value; }
    /**
     * Evento da emettere quando il collapse è nascosto
     * @return {?}
     */
    get hiddenEvent() { return this._hiddenEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hiddenEvent(value) { this._hiddenEvent = value; }
    /**
     * @return {?}
     */
    get cssClass() {
        /** @type {?} */
        let cssClass = 'collapse';
        if (this.isShown()) {
            cssClass += ' show';
        }
        return cssClass;
    }
    /**
     * @return {?}
     */
    show() {
        this.showEvent.emit(this);
        this._isShown = true;
        this.shownEvent.emit(this);
    }
    /**
     * @return {?}
     */
    hide() {
        this.hideEvent.emit(this);
        if (!this._isDisposed) {
            this._isShown = false;
            this.hiddenEvent.emit(this);
        }
    }
    /**
     * @return {?}
     */
    toggle() {
        if (!this.isShown()) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    /**
     * @return {?}
     */
    dispose() {
        this._isDisposed = true;
    }
    /**
     * @return {?}
     */
    isShown() {
        return this._isShown;
    }
}
CollapseDirective.ɵfac = function CollapseDirective_Factory(t) { return new (t || CollapseDirective)(); };
CollapseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CollapseDirective, selectors: [["", "it-collapse", ""]], hostVars: 2, hostBindings: function CollapseDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.cssClass);
    } }, inputs: { itCollapse: ["it-collapse", "itCollapse"] }, outputs: { showEvent: "show", shownEvent: "shown", hideEvent: "hide", hiddenEvent: "hidden" }, exportAs: ["it-collapse"] });
CollapseDirective.propDecorators = {
    itCollapse: [{ type: Input, args: ['it-collapse',] }],
    showEvent: [{ type: Output, args: ['show',] }],
    shownEvent: [{ type: Output, args: ['shown',] }],
    hideEvent: [{ type: Output, args: ['hide',] }],
    hiddenEvent: [{ type: Output, args: ['hidden',] }],
    cssClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapseDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[it-collapse]',
                exportAs: 'it-collapse'
            }]
    }], function () { return []; }, { itCollapse: [{
            type: Input,
            args: ['it-collapse']
        }], showEvent: [{
            type: Output,
            args: ['show']
        }], shownEvent: [{
            type: Output,
            args: ['shown']
        }], hideEvent: [{
            type: Output,
            args: ['hide']
        }], hiddenEvent: [{
            type: Output,
            args: ['hidden']
        }], cssClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$6 = 0;
class CollapseItemComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.id = `collapse-item-${identifier$6++}`;
        this.headingId = `${this.id}-heading`;
        this._showEvent = new EventEmitter();
        this._shownEvent = new EventEmitter();
        this._hideEvent = new EventEmitter();
        this._hiddenEvent = new EventEmitter();
    }
    /**
     * Testo del bottone di apertura/chiusura del collapse item
     * @return {?}
     */
    get header() { return this._header; }
    /**
     * @param {?} value
     * @return {?}
     */
    set header(value) { this._header = value; }
    /**
     * Evento da emettere quando il collapse sta per essere mostrato
     * @return {?}
     */
    get showEvent() { return this._showEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set showEvent(value) { this._showEvent = value; }
    /**
     * Evento da emettere quando il collapse è mostrato
     * @return {?}
     */
    get shownEvent() { return this._shownEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set shownEvent(value) { this._shownEvent = value; }
    /**
     * Evento da emettere quando il collapse sta per essere nascosto
     * @return {?}
     */
    get hideEvent() { return this._hideEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hideEvent(value) { this._hideEvent = value; }
    /**
     * Evento da emettere quando il collapse è nascosto
     * @return {?}
     */
    get hiddenEvent() { return this._hiddenEvent; }
    /**
     * @param {?} value
     * @return {?}
     */
    set hiddenEvent(value) { this._hiddenEvent = value; }
    /**
     * @return {?}
     */
    show() {
        this.showEvent.emit(this);
    }
    /**
     * @return {?}
     */
    hide() {
        this.hideEvent.emit(this);
    }
    /**
     * @return {?}
     */
    shown() {
        this.shownEvent.emit(this);
    }
    /**
     * @return {?}
     */
    hidden() {
        this.hiddenEvent.emit(this);
    }
}
CollapseItemComponent.ɵfac = function CollapseItemComponent_Factory(t) { return new (t || CollapseItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CollapseItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapseItemComponent, selectors: [["it-collapse-item"]], viewQuery: function CollapseItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CollapseDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.directive = _t.first);
    } }, inputs: { header: "header" }, outputs: { showEvent: "show", shownEvent: "shown", hideEvent: "hide", hiddenEvent: "hidden" }, ngContentSelectors: _c1, decls: 8, vars: 9, consts: [[1, "collapse-header", 3, "id"], ["data-toggle", "collapse", 3, "ngClass", "click"], ["toggleButton", ""], ["it-collapse", "", "role", "tabpanel", 3, "id", "show", "hide", "shown", "hidden"], ["collapse", "it-collapse"], [1, "collapse-body"]], template: function CollapseItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r2 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "button", 1, 2);
        ɵngcc0.ɵɵlistener("click", function CollapseItemComponent_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r1 = ɵngcc0.ɵɵreference(5); return _r1.toggle(); });
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "div", 3, 4);
        ɵngcc0.ɵɵlistener("show", function CollapseItemComponent_Template_div_show_4_listener() { return ctx.show(); })("hide", function CollapseItemComponent_Template_div_hide_4_listener() { return ctx.hide(); })("shown", function CollapseItemComponent_Template_div_shown_4_listener() { return ctx.shown(); })("hidden", function CollapseItemComponent_Template_div_hidden_4_listener() { return ctx.hidden(); });
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("id", ctx.headingId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c2, _r1.isShown()));
        ɵngcc0.ɵɵattribute("aria-expanded", _r1.isShown())("aria-controls", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.header, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.headingId);
    } }, directives: [ɵngcc1.NgClass, CollapseDirective], styles: [""] });
/** @nocollapse */
CollapseItemComponent.ctorParameters = () => [
    { type: ElementRef }
];
CollapseItemComponent.propDecorators = {
    directive: [{ type: ViewChild, args: [CollapseDirective,] }],
    header: [{ type: Input }],
    showEvent: [{ type: Output, args: ['show',] }],
    shownEvent: [{ type: Output, args: ['shown',] }],
    hideEvent: [{ type: Output, args: ['hide',] }],
    hiddenEvent: [{ type: Output, args: ['hidden',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapseItemComponent, [{
        type: Component,
        args: [{
                selector: 'it-collapse-item',
                template: `<div class="collapse-header" [id]="headingId">
  <button #toggleButton data-toggle="collapse" [attr.aria-expanded]="collapse.isShown()" [attr.aria-controls]="id" (click)="collapse.toggle()" [ngClass]="{'collapsed' : collapse.isShown()}">
    {{header}}
  </button>
</div>
<div [id]="id" #collapse="it-collapse" it-collapse 
  (show)="show()" (hide)="hide()" (shown)="shown()" (hidden)="hidden()" role="tabpanel" [attr.aria-labelledby]="headingId">
  <div class="collapse-body">
    <ng-content></ng-content>
  </div>
</div>
`,
                styles: [``]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { header: [{
            type: Input
        }], showEvent: [{
            type: Output,
            args: ['show']
        }], shownEvent: [{
            type: Output,
            args: ['shown']
        }], hideEvent: [{
            type: Output,
            args: ['hide']
        }], hiddenEvent: [{
            type: Output,
            args: ['hidden']
        }], directive: [{
            type: ViewChild,
            args: [CollapseDirective]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$7 = 0;
class CollapseGroupComponent {
    constructor() {
        this.id = `collapse-group-${identifier$7++}`;
        this._accordion = false;
    }
    /**
     * Indica se gli item del gruppo sono mutuamente richiudibili (o accordion)
     * @return {?}
     */
    get accordion() { return this._accordion; }
    /**
     * @param {?} value
     * @return {?}
     */
    set accordion(value) { this._accordion = Util.coerceBooleanProperty(value); }
    /**
     * @param {?} target
     * @return {?}
     */
    onClick(target) {
        if (this.accordion) {
            /** @type {?} */
            const items = this._items.toArray();
            items.forEach(currentItem => {
                /** @type {?} */
                const isTargetPartOfItem = (/** @type {?} */ (currentItem.elementRef.nativeElement)).contains(target);
                if (!isTargetPartOfItem) {
                    if (currentItem.directive.isShown()) {
                        currentItem.directive.hide();
                    }
                }
            });
        }
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        if (simpleChanges['accordion']) {
            /** @type {?} */
            const isAccordion = simpleChanges['accordion'].currentValue;
            if (isAccordion) {
                /** @type {?} */
                const items = this._items.toArray();
                items.forEach(currentItem => {
                    if (currentItem.directive.isShown()) {
                        currentItem.directive.hide();
                    }
                });
            }
        }
    }
}
CollapseGroupComponent.ɵfac = function CollapseGroupComponent_Factory(t) { return new (t || CollapseGroupComponent)(); };
CollapseGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CollapseGroupComponent, selectors: [["it-collapse-group"]], contentQueries: function CollapseGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CollapseItemComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
    } }, hostBindings: function CollapseGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CollapseGroupComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); });
    } }, inputs: { accordion: "accordion" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 2, vars: 1, consts: [["role", "tablist", 1, "collapse-div", 3, "id"]], template: function CollapseGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, styles: [""] });
CollapseGroupComponent.propDecorators = {
    accordion: [{ type: Input }],
    _items: [{ type: ContentChildren, args: [forwardRef(() => CollapseItemComponent), { descendants: true },] }],
    onClick: [{ type: HostListener, args: ['click', ['$event.target'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CollapseGroupComponent, [{
        type: Component,
        args: [{
                selector: 'it-collapse-group',
                template: `<div [id]="id" class="collapse-div" role="tablist">
  <ng-content></ng-content>
</div>`,
                styles: [``]
            }]
    }], function () { return []; }, { accordion: [{
            type: Input
        }], 
    /**
     * @param {?} target
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event.target']]
        }], _items: [{
            type: ContentChildren,
            args: [forwardRef(() => CollapseItemComponent), { descendants: true }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const InputType = keyof({
    text: null,
    email: null,
    password: null,
    number: null,
    search: null
});
/** @type {?} */
const TEXT = 'text';
/** @type {?} */
const EMAIL = 'email';
/** @type {?} */
const PASSWORD = 'password';
/** @type {?} */
const NUMBER = 'number';
/** @type {?} */
const SEARCH = 'search';
/** @type {?} */
const INPUT_TYPES = {
    TEXT: TEXT,
    EMAIL: EMAIL,
    PASSWORD: PASSWORD,
    NUMBER: NUMBER,
    SEARCH: SEARCH
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$8 = 0;
class FormInputChange {
    /**
     * @param {?} source
     * @param {?} value
     */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * Elementi e stili per la creazione di input accessibili e responsivi.
 */
class FormInputComponent {
    /**
     * @param {?} _changeDetector
     */
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this._id = `form-input-${identifier$8++}`;
        this._type = INPUT_TYPES.TEXT;
        this._disabled = false;
        this._readonly = false;
        /**
         * Evento emesso quando il valore dell'input cambia.
         * Gli eventi di change sono emessi soltanto quando il valore cambia a causa dell'interazione dell'utente
         * con il campo d'input.
         */
        this.change = new EventEmitter();
        this._isLabelActive = false;
        this._isPasswordMode = false;
        this._isPasswordVisible = false;
        this._showAutocompletion = false;
        this._isInitialized = false;
        this._controlValueAccessorChangeFn = () => { };
        this._onTouched = () => { };
    }
    /**
     * Indica l'id dell'elemento HTML
     * @return {?}
     */
    get id() {
        return this._id;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set id(value) {
        this._id = value;
    }
    /**
     * Indica l'attributo name del componente HTML
     * @return {?}
     */
    get name() {
        return this._name;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set name(value) {
        this._name = value;
    }
    /**
     * Indica il tipo di campo. Puo' assumere i valori text, email, password e number
     * @return {?}
     */
    get type() {
        return this._type;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set type(value) {
        if (InputType.is(value)) {
            if (value === INPUT_TYPES.NUMBER) {
                if (isNaN(Number(this.value))) {
                    this.value = '';
                    this.onChange();
                }
            }
            this._type = value;
        }
        else {
            this._type = INPUT_TYPES.TEXT;
        }
        this._isPasswordMode = this._type === INPUT_TYPES.PASSWORD;
        this._isPasswordVisible = false;
        this._showAutocompletion = false;
    }
    /**
     * Indica il valore della label da visualizzare
     * @return {?}
     */
    get label() { return this._label; }
    /**
     * @param {?} value
     * @return {?}
     */
    set label(value) { this._label = value; }
    /**
     * Indica il testo di aiuto sotto la input
     * @return {?}
     */
    get note() { return this._note; }
    /**
     * @param {?} value
     * @return {?}
     */
    set note(value) { this._note = value; }
    /**
     * Indica il testo presente nel campo vuoto. Nel caso sia già presente la label, il placeholder non verrà mostrato
     * @return {?}
     */
    get placeholder() {
        if (this.label) {
            if (this.label.length > 0) {
                return '';
            }
        }
        return this._placeholder || '';
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set placeholder(value) { this._placeholder = value; }
    /**
     * Indica l'icona da visualizzare a sinistra del campo di input
     * @return {?}
     */
    get icon() { return this._icon; }
    /**
     * @param {?} value
     * @return {?}
     */
    set icon(value) { this._icon = value; }
    /**
     * Opzionale.
     * Indica se il campo in questione è disabilitato.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) { this._disabled = Util.coerceBooleanProperty(value); }
    /**
     * Opzionale.
     * Indica se il campo in questione è di sola lettura.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get readonly() { return this._readonly; }
    /**
     * @param {?} value
     * @return {?}
     */
    set readonly(value) { this._readonly = Util.coerceBooleanProperty(value); }
    /**
     * @return {?}
     */
    get value() { return this._inputElement.nativeElement.value; }
    /**
     * @param {?} value
     * @return {?}
     */
    set value(value) { this._inputElement.nativeElement.value = value; }
    /**
     * Opzionale.
     * Disponibile solo se il type è search.
     * Indica la lista di elementi ricercabili su cui basare il sistema di autocompletamento della input
     * @return {?}
     */
    get autoCompleteData() { return this._autoCompleteData; }
    /**
     * @param {?} value
     * @return {?}
     */
    set autoCompleteData(value) { this._autoCompleteData = value; }
    /**
     * @return {?}
     */
    get isLabelActive() {
        return this._isLabelActive;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isLabelActive(value) {
        this._isLabelActive = Util.coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get isPasswordMode() {
        return this._isPasswordMode;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isPasswordMode(value) {
        this._isPasswordMode = Util.coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get isPasswordVisible() {
        return this._isPasswordVisible;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isPasswordVisible(value) {
        this._isPasswordVisible = Util.coerceBooleanProperty(value);
        this._type = this._isPasswordVisible ? INPUT_TYPES.TEXT : INPUT_TYPES.PASSWORD;
    }
    /**
     * @return {?}
     */
    _emitChangeEvent() {
        if (this._isInitialized) {
            this.change.emit(new FormInputChange(this, this.value));
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.value = value;
        if (this.value) {
            this._isLabelActive = true;
        }
        this.onChange();
        if (this._isInitialized) {
            this._changeDetector.detectChanges();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this._isInitialized = true;
    }
    /**
     * @return {?}
     */
    onChange() {
        this._emitChangeEvent();
        this._controlValueAccessorChangeFn(this.value);
    }
    /**
     * @return {?}
     */
    onInput() {
        if (this._type === INPUT_TYPES.SEARCH && this.isAutocompletable() && !this._showAutocompletion) {
            this._showAutocompletion = true;
        }
        this._emitChangeEvent();
        this._controlValueAccessorChangeFn(this.value);
    }
    /**
     * @return {?}
     */
    onFocus() {
        this._isLabelActive = true;
    }
    /**
     * @return {?}
     */
    onBlur() {
        /** @type {?} */
        const inputValue = this.value;
        if (inputValue.length === 0) {
            this._isLabelActive = false;
            if (this.type === INPUT_TYPES.NUMBER) {
                this.value = '';
            }
        }
    }
    /**
     * @return {?}
     */
    noteId() {
        return `${this.id}-note`;
    }
    /**
     * @return {?}
     */
    getRelatedEntries() {
        if (this.value && this._showAutocompletion) {
            /** @type {?} */
            const lowercaseValue = this.value.toLowerCase();
            /** @type {?} */
            const lowercaseData = this._autoCompleteData.map(string => {
                return { original: string, lowercase: string.toLowerCase() };
            });
            /** @type {?} */
            const relatedEntries = [];
            lowercaseData.forEach(lowercaseEntry => {
                if ((lowercaseEntry.lowercase).includes(lowercaseValue)) {
                    relatedEntries.push(lowercaseEntry.original);
                }
            });
            return relatedEntries;
        }
        else {
            return [];
        }
    }
    /**
     * @return {?}
     */
    isAutocompletable() {
        if (this._autoCompleteData && this._type === INPUT_TYPES.SEARCH) {
            return this._autoCompleteData.length > 0;
        }
        else {
            return false;
        }
    }
    /**
     * @param {?} entry
     * @return {?}
     */
    onEntryClick(entry) {
        this.value = entry;
        this._showAutocompletion = false;
        this.onChange();
    }
}
FormInputComponent.ɵfac = function FormInputComponent_Factory(t) { return new (t || FormInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FormInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormInputComponent, selectors: [["it-input"]], viewQuery: function FormInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
    } }, inputs: { id: "id", name: "name", type: "type", label: "label", note: "note", placeholder: "placeholder", icon: "icon", disabled: "disabled", readonly: "readonly", autoCompleteData: "autoCompleteData" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FormInputComponent),
                multi: true
            }])], decls: 9, vars: 21, consts: [[1, "form-group"], [3, "class", "ngClass", 4, "ngIf"], [3, "type", "id", "disabled", "readonly", "placeholder", "ngClass", "focus", "blur", "change", "input"], ["inputElement", ""], ["class", "btn-eye", 3, "ngClass", "click", 4, "ngIf"], ["class", "autocomplete-wrap", 4, "ngIf"], [3, "ngClass"], ["class", "form-text text-muted", 3, "id", 4, "ngIf"], [1, "btn-eye", 3, "ngClass", "click"], [1, "autocomplete-wrap"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "form-text", "text-muted", 3, "id"]], template: function FormInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormInputComponent_i_1_Template, 1, 4, "i", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function FormInputComponent_Template_input_focus_2_listener() { return ctx.onFocus(); })("blur", function FormInputComponent_Template_input_blur_2_listener() { return ctx.onBlur(); })("change", function FormInputComponent_Template_input_change_2_listener() { return ctx.onChange(); })("input", function FormInputComponent_Template_input_input_2_listener() { return ctx.onInput(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, FormInputComponent_span_4_Template, 1, 4, "span", 4);
        ɵngcc0.ɵɵtemplate(5, FormInputComponent_ul_5_Template, 2, 1, "ul", 5);
        ɵngcc0.ɵɵelementStart(6, "label", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, FormInputComponent_small_8_Template, 2, 2, "small", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("type", ctx.type)("id", ctx.id)("disabled", ctx.disabled)("readonly", ctx.readonly)("placeholder", ctx.placeholder)("ngClass", ɵngcc0.ɵɵpureFunction3(15, _c6, !ctx.readonly, ctx.readonly, ctx.isAutocompletable()));
        ɵngcc0.ɵɵattribute("name", ctx.name)("aria-labelledby", ctx.note ? ctx.noteId : undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isPasswordMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAutocompletable());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c7, ctx.isLabelActive));
        ɵngcc0.ɵɵattribute("for", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.note);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], styles: ["label[_ngcontent-%COMP%]{pointer-events:none}"], changeDetection: 0 });
/** @nocollapse */
FormInputComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
FormInputComponent.propDecorators = {
    _inputElement: [{ type: ViewChild, args: ['inputElement',] }],
    id: [{ type: Input }],
    name: [{ type: Input }],
    type: [{ type: Input }],
    label: [{ type: Input }],
    note: [{ type: Input }],
    placeholder: [{ type: Input }],
    icon: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    autoCompleteData: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormInputComponent, [{
        type: Component,
        args: [{
                selector: 'it-input',
                template: `<div class="form-group">
  <i *ngIf="icon" [class]="icon" [ngClass]="{ 'ico-prefix': true }"></i>
  <input #inputElement
    (focus)="onFocus()"
    (blur)="onBlur()"
    (change)="onChange()"
    (input)="onInput()"
    [type]="type"
    [id]="id"
    [attr.name]="name"
    [disabled]="disabled"
    [readonly]="readonly"
    [placeholder]="placeholder"
    [ngClass]="{
      'form-control' : !readonly,
      'form-control-plaintext' : readonly,
      'autocomplete' : isAutocompletable()
    }"
    [attr.aria-labelledby]="note ? noteId : undefined"/>
  <span class="btn-eye" 
    *ngIf="isPasswordMode"
    (click)="isPasswordVisible = !isPasswordVisible"
    [ngClass]="{
      'eye-on' : !isPasswordVisible,
      'eye-off' : isPasswordVisible
    }">
  </span>
  <ul class="autocomplete-wrap" *ngIf="isAutocompletable()">
    <li *ngFor="let entry of getRelatedEntries()" (click)="onEntryClick(entry)">
      {{entry}}
    </li>
  </ul>
  <label [attr.for]="id" [ngClass]="{ 'active' : isLabelActive }">
    {{label}}
  </label>
  <small [id]="noteId()" class="form-text text-muted" *ngIf="note">
    {{note}}
  </small>
</div>
`,
                styles: [`label{pointer-events:none}`],
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => FormInputComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { change: [{
            type: Output
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], type: [{
            type: Input
        }], label: [{
            type: Input
        }], note: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], icon: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], autoCompleteData: [{
            type: Input
        }], _inputElement: [{
            type: ViewChild,
            args: ['inputElement']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$9 = 0;
/** @type {?} */
const DEFAULT_COLOR = 'dropdown';
/** @type {?} */
const PLACEMENT_PROPERTY = 'x-placement';
/** @type {?} */
const PLACEMENT_VALUE = 'bottom-start';
/**
 * Componente usata per attivare o disattivare overlay contestuali per visualizzare elenchi di link e altro ancora con questi menù a tendina
 */
class DropdownComponent {
    /**
     * @param {?} _eleRef
     */
    constructor(_eleRef) {
        this._eleRef = _eleRef;
        this.id = `dropdown-${identifier$9++}`;
        this._isOpen = false;
        this._dark = false;
        this._fullWidth = false;
        this._color = DEFAULT_COLOR;
        this._label = '';
        this._onOpen = new EventEmitter();
        this._onClose = new EventEmitter();
        this._onToggle = new EventEmitter();
    }
    /**
     * @return {?}
     */
    get isOpen() { return this._isOpen; }
    /**
     * Se presente indica che il dropdown utilizza il tema di colorazione scura.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get dark() { return this._dark; }
    /**
     * @param {?} value
     * @return {?}
     */
    set dark(value) { this._dark = Util.coerceBooleanProperty(value); }
    /**
     * Se presente indica che le voci del dropdown si sviluppano orizzontalmente.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get fullWidth() { return this._fullWidth; }
    /**
     * @param {?} value
     * @return {?}
     */
    set fullWidth(value) { this._fullWidth = Util.coerceBooleanProperty(value); }
    /**
     * Il colore del pulsante che attiva il dropdown.
     * Può assumere i valori primary, secondary, danger, warning, info, warning, success, light e dark
     * @return {?}
     */
    get color() { return this._color; }
    /**
     * @param {?} value
     * @return {?}
     */
    set color(value) {
        if (ThemeColor.is(value)) {
            this._color = value;
        }
        else {
            this._color = DEFAULT_COLOR;
        }
    }
    /**
     * Il testo presente sul pulsante che attiva il dropdown
     * @return {?}
     */
    get label() { return this._label; }
    /**
     * @param {?} value
     * @return {?}
     */
    set label(value) { this._label = value; }
    /**
     * Evento che viene lanciato ogni volta che il dropdown viene aperto
     * @return {?}
     */
    get onOpen() { return this._onOpen; }
    /**
     * @param {?} value
     * @return {?}
     */
    set onOpen(value) { this._onOpen = value; }
    /**
     * Evento che viene lanciato ogni volta che il dropdown viene chiuso
     * @return {?}
     */
    get onClose() { return this._onClose; }
    /**
     * @param {?} value
     * @return {?}
     */
    set onClose(value) { this._onClose = value; }
    /**
     * Evento che viene lanciato ogni volta che il dropdown viene aperto oppure chiuso
     * @return {?}
     */
    get onToggle() { return this._onToggle; }
    /**
     * @param {?} value
     * @return {?}
     */
    set onToggle(value) { this._onToggle = value; }
    /**
     * @param {?} target
     * @return {?}
     */
    onClick(target) {
        if (target === this._dropdownButton.nativeElement) {
            this._toggle();
        }
        else if (this.isOpen) {
            this._close();
        }
    }
    /**
     * @param {?} target
     * @return {?}
     */
    onFocus(target) {
        /** @type {?} */
        const isPartOfDropdown = (/** @type {?} */ (this._eleRef.nativeElement)).contains(target);
        if (!isPartOfDropdown && this.isOpen) {
            this._close();
        }
    }
    /**
     * @return {?}
     */
    get dropdownButtonClass() {
        return `btn btn-${this.color} dropdown-toggle`;
    }
    /**
     * @return {?}
     */
    _toggle() {
        if (this._isOpen) {
            this._close();
        }
        else {
            this._open();
        }
        this.onToggle.emit(this);
    }
    /**
     * @return {?}
     */
    _open() {
        if (!this._isOpen) {
            this._isOpen = true;
            this._dropdownMenu.nativeElement.setAttribute(PLACEMENT_PROPERTY, PLACEMENT_VALUE);
            this.onOpen.emit(this);
        }
    }
    /**
     * @return {?}
     */
    _close() {
        if (this._isOpen) {
            this._isOpen = false;
            this._dropdownMenu.nativeElement.removeAttribute(PLACEMENT_PROPERTY);
            this.onClose.emit(this);
        }
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["it-dropdown"]], viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownMenu = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownButton = _t.first);
    } }, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵngcc0.ɵɵresolveDocument)("focusin", function DropdownComponent_focusin_HostBindingHandler($event) { return ctx.onFocus($event.target); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { dark: "dark", fullWidth: "fullWidth", color: "color", label: "label" }, outputs: { onOpen: "onOpen", onClose: "onClose", onToggle: "onToggle" }, ngContentSelectors: _c1, decls: 9, vars: 13, consts: [[1, "dropdown", 3, "id"], ["type", "button", "id", "dropdownMenuButton", "aria-haspopup", "true"], ["dropdownButton", ""], ["aria-labelledby", "dropdownMenuButton", 1, "dropdown-menu"], ["dropdownMenu", ""], [1, "link-list-wrapper"], [1, "link-list"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "button", 1, 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3, 4)(6, "div", 5)(7, "ul", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("show", ctx.isOpen);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.dropdownButtonClass);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("dark", ctx.dark)("full-width", ctx.fullWidth)("show", ctx.isOpen);
    } }, styles: [""], changeDetection: 0 });
/** @nocollapse */
DropdownComponent.ctorParameters = () => [
    { type: ElementRef }
];
DropdownComponent.propDecorators = {
    _dropdownMenu: [{ type: ViewChild, args: ['dropdownMenu',] }],
    _dropdownButton: [{ type: ViewChild, args: ['dropdownButton',] }],
    dark: [{ type: Input }],
    fullWidth: [{ type: Input }],
    color: [{ type: Input }],
    label: [{ type: Input }],
    onOpen: [{ type: Output }],
    onClose: [{ type: Output }],
    onToggle: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['document:click', ['$event.target'],] }],
    onFocus: [{ type: HostListener, args: ['document:focusin', ['$event.target'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'it-dropdown',
                template: `<div class="dropdown" [class.show]="isOpen" [id]="id">
  <button #dropdownButton [class]="dropdownButtonClass" 
    type="button" id="dropdownMenuButton"
    aria-haspopup="true" [attr.aria-expanded]="isOpen">
    {{label}}
  </button>
  <div #dropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton"
    [class.dark]="dark" [class.full-width]="fullWidth" [class.show]="isOpen">
    <div class="link-list-wrapper">
      <ul class="link-list">
        <ng-content></ng-content>
      </ul>
    </div>
  </div>
</div>
`,
                styles: [``],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { dark: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], color: [{
            type: Input
        }], label: [{
            type: Input
        }], onOpen: [{
            type: Output
        }], onClose: [{
            type: Output
        }], onToggle: [{
            type: Output
        }], 
    /**
     * @param {?} target
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }], 
    /**
     * @param {?} target
     * @return {?}
     */
    onFocus: [{
            type: HostListener,
            args: ['document:focusin', ['$event.target']]
        }], _dropdownMenu: [{
            type: ViewChild,
            args: ['dropdownMenu']
        }], _dropdownButton: [{
            type: ViewChild,
            args: ['dropdownButton']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const IconPosition = keyof({
    right: null,
    left: null
});
/** @type {?} */
const LEFT = 'left';
/** @type {?} */
const RIGHT = 'right';
/** @type {?} */
const ICON_POSITIONS = {
    LEFT: LEFT,
    RIGHT: RIGHT
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$a = 0;
/**
 * Componente usata per visualizzare una voce di menù all'interno di una dropdown
 */
class DropdownItemComponent {
    constructor() {
        this.id = `dropdown-item-${identifier$a++}`;
        this._link = '';
        this._active = false;
        this._disabled = false;
        this._large = false;
        this._icon = undefined;
        this._iconPosition = ICON_POSITIONS.RIGHT;
    }
    /**
     * Il link alla pagina verso cui andare al click sull'elemento del dropdown
     * @return {?}
     */
    get link() { return !this.disabled ? this._link : ''; }
    /**
     * @param {?} value
     * @return {?}
     */
    set link(value) { this._link = value; }
    /**
     * Se presente indica che l'elemento viene renderizzato come elemento attivo.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get active() { return this._active; }
    /**
     * @param {?} value
     * @return {?}
     */
    set active(value) { this._active = Util.coerceBooleanProperty(value); }
    /**
     * Se presente indica che l'elemento è disabilitato.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this._disabled = Util.coerceBooleanProperty(value);
    }
    /**
     * Se presente indica che il testo dell'elemento viene renderizzato più grande.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get large() { return this._large; }
    /**
     * @param {?} value
     * @return {?}
     */
    set large(value) { this._large = Util.coerceBooleanProperty(value); }
    /**
     * La classe dell'icona da usare prima o dopo del testo dell'elemento del dropdown
     * @return {?}
     */
    get icon() { return this._icon; }
    /**
     * @param {?} value
     * @return {?}
     */
    set icon(value) { this._icon = value; }
    /**
     * La posizione dell'icona rispetto al testo dell'elemento del dropdown.
     * Può assumere valori right o left.
     * @return {?}
     */
    get iconPosition() { return this._iconPosition; }
    /**
     * @param {?} value
     * @return {?}
     */
    set iconPosition(value) {
        if (IconPosition.is(value)) {
            this._iconPosition = value;
        }
        else {
            this._iconPosition = ICON_POSITIONS.RIGHT;
        }
    }
    /**
     * @return {?}
     */
    get dropdownItemClass() {
        return `list-item ${this.iconPosition}-icon`;
    }
    /**
     * @return {?}
     */
    get iconClass() {
        return `${this.icon} ${this.iconPosition}`;
    }
}
DropdownItemComponent.ɵfac = function DropdownItemComponent_Factory(t) { return new (t || DropdownItemComponent)(); };
DropdownItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownItemComponent, selectors: [["it-dropdown-item"]], inputs: { link: "link", active: "active", disabled: "disabled", large: "large", icon: "icon", iconPosition: "iconPosition" }, ngContentSelectors: _c1, decls: 6, vars: 13, consts: [[3, "id"], [3, "ngClass"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["aria-hidden", "true"]], template: function DropdownItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "li", 0)(1, "a", 1);
        ɵngcc0.ɵɵtemplate(2, DropdownItemComponent_i_2_Template, 1, 2, "i", 2);
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DropdownItemComponent_i_5_Template, 1, 2, "i", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.dropdownItemClass);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(8, _c10, ctx.large, ctx.active, ctx.disabled, ctx.disabled));
        ɵngcc0.ɵɵattribute("href", ctx.link, ɵngcc0.ɵɵsanitizeUrl)("tabindex", ctx.disabled ? -1 : 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon && ctx.iconPosition === "left");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon && ctx.iconPosition === "right");
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: [".disabled-item-link[_ngcontent-%COMP%]{pointer-events:none}"] });
DropdownItemComponent.propDecorators = {
    link: [{ type: Input }],
    active: [{ type: Input }],
    disabled: [{ type: Input }],
    large: [{ type: Input }],
    icon: [{ type: Input }],
    iconPosition: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownItemComponent, [{
        type: Component,
        args: [{
                selector: 'it-dropdown-item',
                template: `<li [id]="id">
  <a [attr.href]="link"
    [attr.tabindex]="this.disabled ? -1 : 0"
    [class]="dropdownItemClass"
    [ngClass]="{
      'large' : large, 
      'active' : active,
      'disabled' : disabled,
      'disabled-item-link' : disabled
    }">
    <i [class]="iconClass" aria-hidden="true" *ngIf="icon && iconPosition === 'left'"></i>
    <span>
      <ng-content></ng-content>
    </span>
    <i [class]="iconClass" aria-hidden="true" *ngIf="icon && iconPosition === 'right'"></i>
  </a>
</li>`,
                styles: [`.disabled-item-link{pointer-events:none}`]
            }]
    }], function () { return []; }, { link: [{
            type: Input
        }], active: [{
            type: Input
        }], disabled: [{
            type: Input
        }], large: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconPosition: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$b = 0;
class DropdownHeaderComponent {
    constructor() {
        this.id = `dropdown-header-${identifier$b++}`;
    }
}
DropdownHeaderComponent.ɵfac = function DropdownHeaderComponent_Factory(t) { return new (t || DropdownHeaderComponent)(); };
DropdownHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownHeaderComponent, selectors: [["it-dropdown-header"]], ngContentSelectors: _c1, decls: 3, vars: 1, consts: [[3, "id"]], template: function DropdownHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "li", 0)(1, "h3");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'it-dropdown-header',
                template: `<li [id]="id">
  <h3>
    <ng-content></ng-content>
  </h3>
</li>`,
                styles: [``]
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DropdownDividerComponent {
}
DropdownDividerComponent.ɵfac = function DropdownDividerComponent_Factory(t) { return new (t || DropdownDividerComponent)(); };
DropdownDividerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownDividerComponent, selectors: [["it-dropdown-divider"]], decls: 2, vars: 0, consts: [[1, "divider"]], template: function DropdownDividerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li");
        ɵngcc0.ɵɵelement(1, "span", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownDividerComponent, [{
        type: Component,
        args: [{
                selector: 'it-dropdown-divider',
                template: `<li>
  <span class="divider"></span>
</li>`,
                styles: [``]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let identifier$c = 0;
class BreadcrumbItemComponent {
    /**
     * @param {?} _cdRef
     * @param {?} _elemRef
     */
    constructor(_cdRef, _elemRef) {
        this._cdRef = _cdRef;
        this._elemRef = _elemRef;
        this.id = `it-breadcrumb-item-${identifier$c++}`;
        this._isLast = false;
    }
    /**
     * Il link alla pagina verso cui andare al click di questo elemento del breadcrumb
     * @return {?}
     */
    get link() { return this._link; }
    /**
     * @param {?} value
     * @return {?}
     */
    set link(value) { this._link = value; }
    /**
     * La classe dell'icona da usare prima del testo dell'elemento del breadcrumb
     * @return {?}
     */
    get icon() { return this._icon; }
    /**
     * @param {?} value
     * @return {?}
     */
    set icon(value) { this._icon = value; }
    /**
     * @return {?}
     */
    get separator() { return this._separator; }
    /**
     * @param {?} value
     * @return {?}
     */
    set separator(value) { this._separator = value; }
    /**
     * @return {?}
     */
    get isLast() { return this._isLast; }
    /**
     * @param {?} value
     * @return {?}
     */
    set isLast(value) {
        this._isLast = value;
        /** @type {?} */
        const breadcrumbItem = this._elemRef.nativeElement.querySelector('.breadcrumb-item');
        if (this._isLast) {
            breadcrumbItem.setAttribute('aria-current', 'page');
        }
        else {
            if (breadcrumbItem.hasAttribute('aria-current')) {
                breadcrumbItem.removeAttribute('aria-current');
            }
        }
        this._cdRef.detectChanges();
    }
    /**
     * @return {?}
     */
    get breadcrumbClass() {
        return 'breadcrumb-item' + (this.isLast ? ' active' : '');
    }
}
BreadcrumbItemComponent.ɵfac = function BreadcrumbItemComponent_Factory(t) { return new (t || BreadcrumbItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BreadcrumbItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbItemComponent, selectors: [["it-breadcrumb-item"]], inputs: { link: "link", icon: "icon" }, ngContentSelectors: _c1, decls: 5, vars: 6, consts: [[3, "id"], [3, "class", 4, "ngIf"], [3, "href"], ["class", "separator", 4, "ngIf"], [1, "separator"]], template: function BreadcrumbItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵtemplate(1, BreadcrumbItemComponent_i_1_Template, 1, 2, "i", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BreadcrumbItemComponent_span_4_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.breadcrumbClass);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("href", ctx.link, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLast);
    } }, directives: [ɵngcc1.NgIf], styles: [""], changeDetection: 0 });
/** @nocollapse */
BreadcrumbItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
BreadcrumbItemComponent.propDecorators = {
    link: [{ type: Input }],
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbItemComponent, [{
        type: Component,
        args: [{
                selector: 'it-breadcrumb-item',
                template: `<li [class]="breadcrumbClass" [id]="id">
  <i [class]="icon" *ngIf="icon"></i>
  <a [href]="link">
    <ng-content></ng-content>
  </a> <span class="separator" *ngIf="!isLast">{{separator}}</span>
</li>
`,
                styles: [``],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { link: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const DEFAULT_SEPARATOR = '/';
/** @type {?} */
let identifier$d = 0;
/**
 * Una componente che indica la posizione della pagina corrente all’interno di una gerarchia di navigazione
 */
class BreadcrumbComponent {
    constructor() {
        this.id = `it-breadcrumb-${identifier$d++}`;
        this._dark = false;
        this._separator = DEFAULT_SEPARATOR;
        this._subscription = Subscription.EMPTY;
    }
    /**
     * Indica che il breadcrumb utilizza il tema di colorazione scura.
     * Accetta una espressione booleana o può essere usato come attributo senza valore
     * @return {?}
     */
    get dark() { return this._dark; }
    /**
     * @param {?} value
     * @return {?}
     */
    set dark(value) { this._dark = Util.coerceBooleanProperty(value); }
    /**
     * Il carattere che verrà usato come separatore tra gli elementi del breadcrumb
     * @return {?}
     */
    get separator() { return this._separator; }
    /**
     * @param {?} value
     * @return {?}
     */
    set separator(value) { this._separator = value ? value : DEFAULT_SEPARATOR; }
    /**
     * @return {?}
     */
    get breadcrumbClass() {
        return 'breadcrumb' + (this._dark ? ' dark' : '');
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this._reloadBreadcrumbs(this._items);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['separator']) {
            if (!changes['separator'].firstChange) {
                this._reloadBreadcrumbs(this._items);
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }
    /**
     * @param {?} currentItems
     * @return {?}
     */
    _reloadBreadcrumbs(currentItems) {
        currentItems.forEach(item => {
            item.separator = this.separator;
            item.isLast = (item === currentItems.last);
        });
        this._subscribeToChanges();
    }
    /**
     * @return {?}
     */
    _subscribeToChanges() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._subscription = this._items.changes.subscribe(items => {
            this._reloadBreadcrumbs(items);
        });
    }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(); };
BreadcrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["it-breadcrumb"]], contentQueries: function BreadcrumbComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BreadcrumbItemComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
    } }, inputs: { dark: "dark", separator: "separator" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 3, vars: 2, consts: [["aria-label", "breadcrumb", 1, "breadcrumb-container", 3, "id"], [3, "ngClass"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0)(1, "ol", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.breadcrumbClass);
    } }, directives: [ɵngcc1.NgClass], styles: [""], changeDetection: 0 });
BreadcrumbComponent.propDecorators = {
    dark: [{ type: Input }],
    separator: [{ type: Input }],
    _items: [{ type: ContentChildren, args: [forwardRef(() => BreadcrumbItemComponent), { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'it-breadcrumb',
                template: `<nav class="breadcrumb-container" aria-label="breadcrumb" [id]="id">
  <ol [ngClass]="breadcrumbClass">
    <ng-content></ng-content>
  </ol>
</nav>`,
                styles: [``],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { dark: [{
            type: Input
        }], separator: [{
            type: Input
        }], _items: [{
            type: ContentChildren,
            args: [forwardRef(() => BreadcrumbItemComponent), { descendants: true }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Un componente tab con design bootstrap italia. Indica la singola tab di un insieme di tab.
 * Utilizzabile con il tag `<it-tab>` all'interno di un tag `<it-tab-group>`.
 */
class TabComponent {
    constructor() {
        /**
         * Testo della tab.
         */
        this.label = '';
        this._disabled = false;
        /**
         * La stringa rappresentante l'icona da utilizzare nel titolo della tab. Es. `it-file`
         */
        this.icon = null;
        /**
         * Emette un evento ogni volta che la label cambia.
         */
        this._labelChange = new Subject();
        /**
         * Emette un evento ogni volta che l'attributo disabled cambia
         */
        this._disableChange = new Subject();
        /**
         * La posizione relativa della tab dove 0 rappresenta il centro, i negativi sono a sinistra
         * e i positivi sono a destra.
         */
        this.position = null;
        /**
         * Se il tab è attivo.
         */
        this.isActive = false;
    }
    /**
     * Se la tab è disabilitata.
     * @return {?}
     */
    get disabled() { return this._disabled; }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this._disabled = Util.coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._disableChange.complete();
        this._labelChange.complete();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('label')
            || changes.hasOwnProperty('ariaLabel')
            || changes.hasOwnProperty('ariaLabelledby')) {
            this._labelChange.next();
        }
        if (changes.hasOwnProperty('disabled')) {
            this._disableChange.next();
        }
    }
}
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(); };
TabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabComponent, selectors: [["it-tab"]], viewQuery: function TabComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._implicitContent = _t.first);
    } }, inputs: { label: "label", icon: "icon", disabled: "disabled", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"] }, exportAs: ["itTab"], features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 1, vars: 0, template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TabComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, styles: [""], encapsulation: 2, changeDetection: 0 });
TabComponent.propDecorators = {
    label: [{ type: Input }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    ariaLabelledby: [{ type: Input, args: ['aria-labelledby',] }],
    disabled: [{ type: Input }],
    icon: [{ type: Input }],
    _implicitContent: [{ type: ViewChild, args: [TemplateRef,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{
                selector: 'it-tab',
                exportAs: 'itTab',
                template: `<ng-template><ng-content></ng-content></ng-template>
`,
                styles: [``],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], icon: [{
            type: Input
        }], disabled: [{
            type: Input
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], ariaLabelledby: [{
            type: Input,
            args: ['aria-labelledby']
        }], _implicitContent: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** *
 * Usato per generare ID univoci per ogni componente tab
  @type {?} */
let nextId = 0;
/**
 * Un change event emesso ai cambi di selezione.
 */
class TabChangeEvent {
}
/**
 * Un componente tab-group con design bootstrap italia. Utilizzabile con il tag `<it-tab-group>`.
 *
 * Supporta al suo interno tab di base `<it-tab>` con una label e un contenuto.
 */
class TabGroupComponent {
    /**
     * @param {?} _changeDetectorRef
     */
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        /**
         * L'indice del tab che dovrebbe essere selezionato dopo che il contenuto e' stato controllato
         */
        this._indexToSelect = 0;
        /**
         * Subscription all'aggiunta e rimozione di tab.
         */
        this._tabsSubscription = Subscription.EMPTY;
        /**
         * Subscription ai cambiamenti alle label dei tab.
         */
        this._tabLabelSubscription = Subscription.EMPTY;
        this._isPill = false;
        this._selectedIndex = null;
        this._dark = false;
        /**
         * abilita il supporto al data-binding bidirezionale `[(selectedIndex)]`
         */
        this.selectedIndexChange = new EventEmitter();
        /**
         * emesso quando la selezione del tab cambia.
         */
        this.selectedTabChange = new EventEmitter(true);
        this._groupId = nextId++;
    }
    /**
     * Se le tab sono formattate come pill.
     * @return {?}
     */
    get pill() { return this._isPill; }
    /**
     * @param {?} value
     * @return {?}
     */
    set pill(value) {
        this._isPill = Util.coerceBooleanProperty(value);
    }
    /**
     * L'indice della tab attiva.
     * @return {?}
     */
    get selectedIndex() { return this._selectedIndex; }
    /**
     * @param {?} value
     * @return {?}
     */
    set selectedIndex(value) {
        this._indexToSelect = Util.coerceNumberProperty(value, null);
    }
    /**
     * Se il tab-group ha un tema scuro
     * @return {?}
     */
    get dark() { return this._dark; }
    /**
     * @param {?} value
     * @return {?}
     */
    set dark(value) {
        this._dark = Util.coerceBooleanProperty(value);
    }
    /**
     * Dopo che il contenuto è controllato, il componente conosce i tab che sono stati definiti
     * e qual è l'indice del tab selezionato.
     * @return {?}
     */
    ngAfterContentChecked() {
        this.changeTab(this._indexToSelect);
    }
    /**
     * @param {?} newIndex
     * @return {?}
     */
    changeTab(newIndex) {
        /** @type {?} */
        const indexToSelect = this._indexToSelect = this._clampTabIndex(newIndex);
        // Se il nuovo tab è disabilitato, non fare niente
        if (this._tabs && this._tabs.length > 0 && this._tabs.toArray()[indexToSelect].disabled) {
            return;
        }
        if (this._selectedIndex !== indexToSelect && this._selectedIndex != null) {
            /** @type {?} */
            const tabChangeEvent = this._createChangeEvent(indexToSelect);
            this.selectedTabChange.emit(tabChangeEvent);
            // Emetto questo valore dopo che è partita la change detection
            // dal momento che il contenuto controllato potrebbe contenere questa variabile
            Promise.resolve().then(() => this.selectedIndexChange.emit(indexToSelect));
        }
        // Setta la posizione per ogni tab.
        this._tabs.forEach((tab, index) => {
            tab.position = index - indexToSelect;
            tab.isActive = index === indexToSelect;
        });
        if (this._selectedIndex !== indexToSelect) {
            this._selectedIndex = indexToSelect;
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this._subscribeToTabLabels();
        // Sottoscrivi al cambiamento nel numero di tab, così da
        // poter ri-renderizzare il contenuto quando nuove tab vengono aggiunte o rimosse.
        this._tabsSubscription = this._tabs.changes.subscribe(() => {
            /** @type {?} */
            const indexToSelect = this._clampTabIndex(this._indexToSelect);
            // Mantieni il tab selezionato precedentemente se un nuovo tab è aggiunto o rimosso e non ci sono
            // cambiamenti espliciti che selezionino un tab differente.
            if (indexToSelect === this._selectedIndex) {
                /** @type {?} */
                const tabs = this._tabs.toArray();
                for (let i = 0; i < tabs.length; i++) {
                    if (tabs[i].isActive) {
                        // Assegna `_indexToSelect` e `_selectedIndex` in modo da non emettere un change event
                        // per evitare al consumer loop infiniti in alcuni casi limite come ad esempio
                        // se si aggiunge un tab all'interno dell'evento `selectedIndexChange`.
                        this._indexToSelect = this._selectedIndex = i;
                        break;
                    }
                }
            }
            this._subscribeToTabLabels();
            this._changeDetectorRef.markForCheck();
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._tabsSubscription.unsubscribe();
        this._tabLabelSubscription.unsubscribe();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    _createChangeEvent(index) {
        /** @type {?} */
        const event = new TabChangeEvent;
        event.index = index;
        if (this._tabs && this._tabs.length) {
            event.tab = this._tabs.toArray()[index];
        }
        return event;
    }
    /**
     * Sottoscrivi a cambiamenti nelle label dei tab. Necessario perchè l'input per la label è sul TabComponent
     * mentre il data binding è all'interno di TabGroupComponent. Per fare in modo che il binding sia aggiornato
     * bisogna sottoscriversi ai cambiamenti e azionare la change detection in maniera manuale.
     * @return {?}
     */
    _subscribeToTabLabels() {
        if (this._tabLabelSubscription) {
            this._tabLabelSubscription.unsubscribe();
        }
        this._tabLabelSubscription = merge(...this._tabs.map(tab => tab._disableChange), ...this._tabs.map(tab => tab._labelChange)).subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }
    /**
     * fissa l'indice tra 0 e la dimensione dei tab.
     * @param {?} index
     * @return {?}
     */
    _clampTabIndex(index) {
        return Math.min(this._tabs.length - 1, Math.max(index || 0, 0));
    }
    /**
     * ritorna un id univoco per ogni label di tab
     * @param {?} i
     * @return {?}
     */
    _getTabLabelId(i) {
        return `it-tab-label-${this._groupId}-${i}`;
    }
    /**
     * ritorna un id univoco per ogni elemento di contenuto del tab
     * @param {?} i
     * @return {?}
     */
    _getTabContentId(i) {
        return `it-tab-content-${this._groupId}-${i}`;
    }
    /**
     * restituisce il tabIndex del tab.
     * @param {?} tab
     * @param {?} idx
     * @return {?}
     */
    _getTabIndex(tab, idx) {
        if (tab.disabled) {
            return null;
        }
        return this.selectedIndex === idx ? 0 : -1;
    }
    /**
     * @param {?} $event
     * @param {?} index
     * @return {?}
     */
    _handleClick($event, index) {
        $event.preventDefault();
        this.changeTab(index);
    }
}
TabGroupComponent.ɵfac = function TabGroupComponent_Factory(t) { return new (t || TabGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
TabGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabGroupComponent, selectors: [["it-tab-group"]], contentQueries: function TabGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabs = _t);
    } }, inputs: { pill: "pill", selectedIndex: "selectedIndex", dark: "dark" }, outputs: { selectedIndexChange: "selectedIndexChange", selectedTabChange: "selectedTabChange" }, exportAs: ["itTabGroup"], decls: 4, vars: 7, consts: [["role", "tablist", 1, "nav", 3, "ngClass"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "tab-content"], [4, "ngFor", "ngForOf"], [1, "nav-item"], ["href", "#", "role", "tab", 3, "ngClass", "id", "click"], ["class", "it-ico-lg d-block text-center", 3, "ngClass", 4, "ngIf"], [1, "it-ico-lg", "d-block", "text-center", 3, "ngClass"], ["role", "tabpanel", 3, "ngClass", "id"], [4, "ngTemplateOutlet"]], template: function TabGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, TabGroupComponent_li_1_Template, 4, 11, "li", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TabGroupComponent_ng_container_3_Template, 3, 6, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(3, _c13, ctx.dark, !ctx.pill, ctx.pill));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._tabs);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._tabs);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [""], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
TabGroupComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
TabGroupComponent.propDecorators = {
    _tabs: [{ type: ContentChildren, args: [TabComponent,] }],
    pill: [{ type: Input }],
    selectedIndex: [{ type: Input }],
    dark: [{ type: Input }],
    selectedIndexChange: [{ type: Output }],
    selectedTabChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabGroupComponent, [{
        type: Component,
        args: [{
                selector: 'it-tab-group',
                exportAs: 'itTabGroup',
                template: `<ul class="nav" [ngClass]="{'nav-dark': dark, 'nav-tabs': !pill, 'nav-pills mb-3': pill}" role="tablist">

  <li class="nav-item" *ngFor="let tab of _tabs; let i = index">
    <a
      href="#"
      role="tab"
      [attr.aria-controls]="_getTabContentId(i)"
      [attr.aria-selected]="selectedIndex == i"
      [attr.aria-label]="tab.ariaLabel || null"
      [attr.aria-labelledby]="(!tab.ariaLabel && tab.ariaLabelledby) ? tab.ariaLabelledby : null"
      [ngClass]="{ 'nav-link': true, 'active': selectedIndex == i, 'disabled': tab.disabled }"
      [id]="_getTabLabelId(i)"
      (click)="_handleClick($event, i)">
      <i *ngIf="tab.icon" class="it-ico-lg d-block text-center" [ngClass]="tab.icon"></i>
      {{tab.label}}
    </a>
  </li>
</ul>
<div class="tab-content">
  <ng-container *ngFor="let tab of _tabs; let i = index">
    <div
      [ngClass]="{ 'tab-pane p-3': true, 'show active': selectedIndex == i }"
      [id]="_getTabContentId(i)"
      role="tabpanel"
      [attr.aria-labelledby]="_getTabLabelId(i)">
      <ng-container *ngTemplateOutlet="tab._implicitContent"></ng-container>
    </div>
  </ng-container>
</div>
`,
                styles: [``],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { selectedIndexChange: [{
            type: Output
        }], selectedTabChange: [{
            type: Output
        }], pill: [{
            type: Input
        }], selectedIndex: [{
            type: Input
        }], dark: [{
            type: Input
        }], _tabs: [{
            type: ContentChildren,
            args: [TabComponent]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DesignAngularKitModule {
}
DesignAngularKitModule.ɵfac = function DesignAngularKitModule_Factory(t) { return new (t || DesignAngularKitModule)(); };
DesignAngularKitModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DesignAngularKitModule });
DesignAngularKitModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesignAngularKitModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    CheckboxComponent,
                    ToggleComponent,
                    RadioGroupDirective,
                    RadioButtonComponent,
                    BadgeDirective,
                    TabGroupComponent,
                    TabComponent,
                    ProgressBarComponent,
                    ButtonComponent,
                    TooltipDirective,
                    TooltipComponent,
                    CollapseDirective,
                    CollapseItemComponent,
                    CollapseGroupComponent,
                    FormInputComponent,
                    PopoverDirective,
                    PopoverComponent,
                    DropdownComponent,
                    DropdownItemComponent,
                    DropdownHeaderComponent,
                    DropdownDividerComponent,
                    BreadcrumbComponent,
                    BreadcrumbItemComponent
                ],
                exports: [
                    CheckboxComponent,
                    ToggleComponent,
                    RadioGroupDirective,
                    RadioButtonComponent,
                    BadgeDirective,
                    TabGroupComponent,
                    TabComponent,
                    ProgressBarComponent,
                    ButtonComponent,
                    TooltipDirective,
                    CollapseDirective,
                    CollapseItemComponent,
                    CollapseGroupComponent,
                    FormInputComponent,
                    PopoverDirective,
                    DropdownComponent,
                    DropdownItemComponent,
                    DropdownHeaderComponent,
                    DropdownDividerComponent,
                    BreadcrumbComponent,
                    BreadcrumbItemComponent
                ],
                entryComponents: [TooltipComponent, PopoverComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DesignAngularKitModule, { declarations: function () { return [CheckboxComponent, ToggleComponent, RadioGroupDirective, RadioButtonComponent, BadgeDirective, TabGroupComponent, TabComponent, ProgressBarComponent, ButtonComponent, TooltipDirective, TooltipComponent, CollapseDirective, CollapseItemComponent, CollapseGroupComponent, FormInputComponent, PopoverDirective, PopoverComponent, DropdownComponent, DropdownItemComponent, DropdownHeaderComponent, DropdownDividerComponent, BreadcrumbComponent, BreadcrumbItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [CheckboxComponent, ToggleComponent, RadioGroupDirective, RadioButtonComponent, BadgeDirective, TabGroupComponent, TabComponent, ProgressBarComponent, ButtonComponent, TooltipDirective, CollapseDirective, CollapseItemComponent, CollapseGroupComponent, FormInputComponent, PopoverDirective, DropdownComponent, DropdownItemComponent, DropdownHeaderComponent, DropdownDividerComponent, BreadcrumbComponent, BreadcrumbItemComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { ProgressBarComponent, CheckboxChange, CheckboxComponent, PopoverDirective, PopoverConfig, ToggleChange, ToggleComponent, RadioChange, RadioGroupDirective, RadioButtonComponent, TooltipDirective, TooltipConfig, ButtonComponent, BadgeDirective, CollapseDirective, CollapseItemComponent, CollapseGroupComponent, FormInputChange, FormInputComponent, DropdownComponent, DropdownItemComponent, DropdownHeaderComponent, DropdownDividerComponent, BreadcrumbComponent, BreadcrumbItemComponent, TabChangeEvent, TabGroupComponent, DesignAngularKitModule, PopoverComponent as ɵd, UniqueSelectionDispatcher as ɵa, TabComponent as ɵb, TooltipComponent as ɵc };

